/*
  SLB__GENERATED_CMR__DO_NOT_EDIT
  Build-Version: SLB_V4_133_JEE_CHAT_TRANSACTION_CONSOLE_20260910_01
  Source: /slb_src/cmr/slb.cmr.src.js
  Built: 2026-09-19T16:53:54.609Z
  Content-SHA256: 033d5c83f4bbecee38cf5464bbe273e8448482b999d5f91651cb72bd1021b9ed
*/

/* SLB CMR module (Celestial Medic Report) - injected pulse tool + records (V1.0 STABLE add-on) | PATCH9_20260113
   - User tab: CMR (under Records)
   - Admin tab: CMR Inbox (under Admin)
*/
(function(){
  if(window.__SLB_CMR_INIT__) return;
  window.__SLB_CMR_INIT__ = true;

  function qs(sel, root){ return (root||document).querySelector(sel); }
  function qsa(sel, root){ return Array.from((root||document).querySelectorAll(sel)); }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
  function nl2br(s){ return esc(s).replace(/\n/g,'<br>'); }

  function toDate_(s){
    try{
      var d = new Date(s);
      if(!d || isNaN(d.getTime())) return null;
      return d;
    }catch(_e){ return null; }
  }
  function pad2_(n){
    n = parseInt(n,10);
    if(isNaN(n)) n = 0;
    return (n<10?'0':'') + n;
  }
  function fmtYmd_(d){
    if(!d) return '';
    return d.getFullYear() + '-' + pad2_(d.getMonth()+1) + '-' + pad2_(d.getDate());
  }
  function fmtHm_(d){
    if(!d) return '';
    try{ return pad2_(d.getHours()) + ':' + pad2_(d.getMinutes()); }catch(_e){ return ''; }
  }
  function fmtDateKey_(dk){
    dk = String(dk||'').trim();
    if(!dk) return '';
    if(/^\d{4}-\d{2}-\d{2}$/.test(dk)) return dk;
    var d = toDate_(dk);
    if(d) return fmtYmd_(d);
    var m = dk.match(/(\d{4}-\d{2}-\d{2})/);
    if(m) return m[1];
    return dk.length>10 ? dk.slice(0,10) : dk;
  }
  function fmtDateTime_(iso){
    var d = toDate_(iso);
    if(!d) return String(iso||'');
    return fmtYmd_(d) + ' ' + fmtHm_(d);
  }
  function timeAgo_(iso){
    var d = toDate_(iso);
    if(!d) return '';
    var ms = Date.now() - d.getTime();
    if(ms < 0) ms = 0;
    var s = Math.floor(ms/1000);
    if(s < 60) return s + 's ago';
    var m = Math.floor(s/60);
    if(m < 60) return m + 'm ago';
    var h = Math.floor(m/60);
    if(h < 48) return h + 'h ago';
    var days = Math.floor(h/24);
    if(days < 60) return days + 'd ago';
    var mo = Math.floor(days/30);
    if(mo < 24) return mo + 'mo ago';
    var y = Math.floor(mo/12);
    return y + 'y ago';
  }


  function rpc(action, args, opts){
    var API = window.SLB_APP;
    if(!API || typeof API.rpc !== 'function') throw new Error('SLB_APP.rpc not ready');
    return API.rpc(action, args||{}, opts||{});
  }

  function getRole(){
    try{
      var S = window.SLB_APP && window.SLB_APP.S;
      var callsign = (S && (S.callsign || (S.role && S.role.callsign))) || (sessionStorage.getItem('tyw_callsign')||'') || '';
      callsign = String(callsign||'').trim().toUpperCase();
      var isAdmin = !!(S && (S.isAdmin || (S.role && S.role.isAdmin)));
      var isModerator = !!(S && (S.isModerator || (S.role && S.role.isModerator)));
      // Some builds store a combined flag
      var isAdminOrMod = !!(S && (S.isAdminOrMod || S.isAdminOrModerator || (S.role && (S.role.isAdminOrMod || S.role.isAdminOrModerator))));
      if(!isAdminOrMod) isAdminOrMod = (isAdmin || isModerator);

      return { callsign: callsign, isAdmin: isAdmin, isModerator: isModerator, isAdminOrMod: isAdminOrMod };
    }catch(_e){
      return { callsign:'', isAdmin:false, isModerator:false, isAdminOrMod:false };
    }
  }

  function toast(msg, ms){
    try{
      if(window.SLB && window.SLB.ui && typeof window.SLB.ui.toast==='function'){
        return window.SLB.ui.toast(msg, ms);
      }
    }catch(_e){}
    try{ if(window.SLB_APP && typeof window.SLB_APP.toast==='function') return window.SLB_APP.toast(msg); }catch(_e2){}
    try{ if(!window.SLB_DEBUG) return; console.log('[CMR]', msg); }catch(_e3){}
  }

  function injectStyleOnce(id, cssText){
    if(document.getElementById(id)) return;
    var st = document.createElement('style');
    st.id = id;
    st.textContent = cssText;
    document.head.appendChild(st);
  }

  // ===== Minimal Rich Editor (contenteditable) =====
  function buildMiniEditor(opts){
    opts = opts||{};
    var id = opts.id || ('ed_'+Math.random().toString(16).slice(2));
    var label = opts.label || '';
    var placeholder = opts.placeholder || '';
    var html = `
      <div class="slbCmrEd">
        <div class="slbCmrEdTop">
          <div class="slbCmrEdLabel">${esc(label)}</div>
          <div class="slbCmrEdBtns">
            <button class="btn ghost slbCmrEdCmd" data-cmd="bold" type="button"><b>B</b></button>
            <button class="btn ghost slbCmrEdCmd" data-cmd="italic" type="button"><i>I</i></button>
            <button class="btn ghost slbCmrEdCmd" data-cmd="underline" type="button"><u>U</u></button>
            <button class="btn ghost slbCmrEdCmd" data-cmd="strikeThrough" type="button"><s>S</s></button>
            <input class="slbCmrEdColor" type="color" title="Text color" />
            <select class="slbCmrEdSize" title="Text size">
              <option value="2">Small</option>
              <option value="3" selected>Normal</option>
              <option value="4">Large</option>
              <option value="5">XL</option>
            </select>
            <button class="btn ghost slbCmrEdCmd" data-cmd="removeFormat" type="button">Clear</button>
          </div>
        </div>
        <div id="${id}" class="slbCmrEdBox richEditor slbStdArea" contenteditable="true" data-slbeditor-area spellcheck="false" data-placeholder="${esc(placeholder)}"></div>
      </div>
    `;
    return { id: id, html: html };
  }

  function wireMiniEditor(root, editorId){
    var box = document.getElementById(editorId);
    if(!box) return null;

    function exec(cmd, val){
      try{ document.execCommand(cmd, false, val); box.focus(); }catch(_e){}
    }

    qsa('.slbCmrEdCmd', root).forEach(function(b){
      b.addEventListener('click', function(){
        exec(String(b.getAttribute('data-cmd')||''), null);
      });
    });

    var color = qs('.slbCmrEdColor', root);
    if(color){
      color.addEventListener('input', function(){ exec('foreColor', color.value); });
    }
    var size = qs('.slbCmrEdSize', root);
    if(size){
      size.addEventListener('change', function(){ exec('fontSize', size.value); });
    }

    return {
      setHtml: function(h){ box.innerHTML = String(h||''); },
      getHtml: function(){ return box.innerHTML || ''; },
      getText: function(){ return (box.innerText || '').trim(); },
      focus: function(){ try{ box.focus(); }catch(_e){} }
    };
  }



  // ===== Shared Rich Editor (one toolbar controls multiple boxes) =====
  function buildDualEditor(opts){
    opts = opts||{};
    var reportId = opts.reportId || ('rep_'+Math.random().toString(16).slice(2));
    var notesId = opts.notesId || ('not_'+Math.random().toString(16).slice(2));
    var label = (opts.label !== undefined) ? String(opts.label||'') : 'Edit';
    var reportLabel = (opts.reportLabel !== undefined) ? String(opts.reportLabel||'') : 'Report';
    var notesLabel = (opts.notesLabel !== undefined) ? String(opts.notesLabel||'') : 'Notes (optional)';
    var reportPh = opts.reportPlaceholder || 'Edit report here...';
    var notesPh = opts.notesPlaceholder || 'Add notes here...';

    var html = `
      <div class="slbCmrEd slbCmrEdShared">
        <div class="slbCmrEdTop">
          <div class="slbCmrEdLabel">${esc(label)}</div>
        </div>

        <div class="slbCmrEdToolbar" style="padding:8px 10px;border-bottom:1px solid var(--border);">
          <div class="slbWysToolbar slbCmrWysToolbar" data-scope="cmr-my"></div>
        </div>

        <div class="slbCmrEdDual">
          <div class="slbCmrEdSubLabel">${esc(reportLabel)}</div>
          <div id="${reportId}" class="slbCmrEdBox slbCmrEdBoxTall richEditor slbStdArea" contenteditable="true" data-slbeditor-area spellcheck="false" data-placeholder="${esc(reportPh)}"></div>

          <div class="slbCmrEdSubLabel" style="margin-top:10px;">${esc(notesLabel)}</div>
          <div id="${notesId}" class="slbCmrEdBox slbCmrEdBoxSmall richEditor slbStdArea" contenteditable="true" data-slbeditor-area spellcheck="false" data-placeholder="${esc(notesPh)}"></div>
        </div>
      </div>
    `;
    return { reportId: reportId, notesId: notesId, html: html };
  }


  function wireDualEditor(root, reportId, notesId){
    var rep = document.getElementById(reportId);
    var not = document.getElementById(notesId);
    if(!rep || !not) return null;

    var toolbar = qs('.slbCmrWysToolbar', root);
    if(toolbar && (!toolbar.dataset || toolbar.dataset.filled !== '1')){
      if(toolbar.dataset) toolbar.dataset.filled = '1';
      toolbar.innerHTML = cmrFullToolbarHtml_('slbCmrMy');
    }

    // --- helpers (rich html sanitize + text extraction) ---
    function sanitizeRichHtml(html){
      html = String(html||'');
      try{ html = html.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi,''); }catch(_e){}
      try{ html = html.replace(/ on[a-z]+\s*=\s*"[^"]*"/gi,''); }catch(_e){}
      try{ html = html.replace(/ on[a-z]+\s*=\s*'[^']*'/gi,''); }catch(_e){}
      try{ html = html.replace(/javascript:/gi,''); }catch(_e){}
      // keep a conservative subset
      try{
        var allowed = ['B','STRONG','I','EM','U','S','STRIKE','P','BR','DIV','SPAN','UL','OL','LI','H1','H2','H3','BLOCKQUOTE','A','HR'];
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        (function walk(node){
          var kids = Array.from(node.childNodes||[]);
          for(var i=0;i<kids.length;i++){
            var ch = kids[i];
            if(ch.nodeType === 1){
              var tag = ch.tagName;
              if(allowed.indexOf(tag) === -1){
                // unwrap
                while(ch.firstChild) node.insertBefore(ch.firstChild, ch);
                node.removeChild(ch);
                continue;
              }
              // strip attrs except style for span + href for a
              var attrs = Array.from(ch.attributes||[]);
              attrs.forEach(function(a){
                var n = String(a.name||'').toLowerCase();
                if(tag === 'A' && (n === 'href' || n === 'target' || n === 'rel')) return;
                if(tag === 'SPAN' && n === 'style') return;
                if(tag === 'DIV' && n === 'style') return;
                if(tag === 'P' && n === 'style') return;
                ch.removeAttribute(a.name);
              });
              if(tag === 'A'){
                try{ ch.setAttribute('target','_blank'); ch.setAttribute('rel','noopener'); }catch(_e){}
              }
              walk(ch);
            }
          }
        })(tmp);
        html = tmp.innerHTML;
      }catch(_e){}
      return html;
    }

    function htmlToText(html){
      try{
        var d = document.createElement('div');
        d.innerHTML = String(html||'');
        var t = (d.innerText || d.textContent || '').trim();
        return t;
      }catch(_e){
        return String(html||'').replace(/<[^>]+>/g,' ').replace(/\s+/g,' ').trim();
      }
    }

    // --- multi editor wiring ---
    var editors = [rep, not];
    var active = rep;
    var lastRange = null;

    function setActive(el){ if(el) active = el; }
    editors.forEach(function(el){
      el.addEventListener('focus', function(){ setActive(el); });
      el.addEventListener('click', function(){ setActive(el); saveRange(); });
      el.addEventListener('keyup', function(){ setActive(el); saveRange(); });
      el.addEventListener('mouseup', function(){ setActive(el); saveRange(); });
    });

    function saveRange(){
      try{
        var sel = window.getSelection ? window.getSelection() : null;
        if(sel && sel.rangeCount){ lastRange = sel.getRangeAt(0); }
      }catch(_e){}
    }
    function restoreRange(){
      try{
        if(!lastRange) return;
        var sel = window.getSelection ? window.getSelection() : null;
        if(!sel) return;
        sel.removeAllRanges();
        sel.addRange(lastRange);
      }catch(_e){}
    }

    function focus(){
      try{ (active||rep).focus(); }catch(_e){}
    }

    function exec(cmd, val){
      try{ document.execCommand('styleWithCSS', false, true); }catch(_e){}
      try{ document.execCommand(cmd, false, val); }catch(_e2){}
    }

    function wrapSelection(style){
      try{
        var sel = window.getSelection ? window.getSelection() : null;
        if(!sel || !sel.rangeCount) return false;
        var range = sel.getRangeAt(0);
        if(range.collapsed) return false;
        var span = document.createElement('span');
        span.setAttribute('style', style);
        range.surroundContents(span);
        return true;
      }catch(_e){
        return false;
      }
    }

    // toolbar binding
    function closeEmoji_(){
      try{ toolbar.querySelectorAll('.slbEmojiPanel').forEach(function(p){ p.classList.add('hidden'); }); }catch(_e){}
    }

    var emojiDocBound = false;
    function toggleEmoji_(btn){
      try{
        var wrap = btn && btn.closest ? btn.closest('.slbEmojiWrap') : null;
        var panel = wrap ? wrap.querySelector('.slbEmojiPanel') : null;
        if(!panel){ closeEmoji_(); return; }
        var wasOpen = !panel.classList.contains('hidden');
        closeEmoji_();
        if(wasOpen) return;
        panel.classList.remove('hidden');
        if(!emojiDocBound){
          emojiDocBound = true;
          document.addEventListener('click', function(e){
            try{
              if(!toolbar.contains(e.target)) return closeEmoji_();
              var w = e.target && e.target.closest ? e.target.closest('.slbEmojiWrap') : null;
              if(!w) closeEmoji_();
            }catch(_e){}
          }, true);
        }
      }catch(_e){}
    }

    if(toolbar){
      toolbar.addEventListener('mousedown', function(ev){
        var t = ev.target && ev.target.closest ? ev.target.closest('button,select,input') : null;
        if(t){
          saveRange();
          try{ if(t.tagName === 'BUTTON') ev.preventDefault(); }catch(_e){}
        }
      });

      toolbar.addEventListener('click', function(ev){
        var btn = ev.target && ev.target.closest ? ev.target.closest('button') : null;
        if(!btn) return;

        var emoji = btn.getAttribute('data-emoji');
        var wcolor = btn.getAttribute('data-wcolor');
        var wbg = btn.getAttribute('data-wbg');
        var cmd = String(btn.getAttribute('data-wcmd')||'');
        var wval = btn.getAttribute('data-wval');

        if(emoji){
          restoreRange();
          focus();
          closeEmoji_();
          exec('insertText', String(emoji));
          (active||rep).innerHTML = sanitizeRichHtml((active||rep).innerHTML);
          return;
        }

        if(cmd === 'emoji'){
          toggleEmoji_(btn);
          return;
        }

        closeEmoji_();
        restoreRange();
        focus();

        if(wcolor){
          var c1 = String(wcolor||'').trim();
          if(!c1) return;
          if(!wrapSelection('color:' + c1 + ';')){
            try{ document.execCommand('foreColor', false, c1); }catch(_e){}
          }
          (active||rep).innerHTML = sanitizeRichHtml((active||rep).innerHTML);
          return;
        }

        if(wbg){
          var c2 = String(wbg||'').trim();
          if(!c2) return;
          if(!wrapSelection('background-color:' + c2 + ';')){
            try{ document.execCommand('hiliteColor', false, c2); }catch(_e){
              try{ document.execCommand('backColor', false, c2); }catch(_e2){}
            }
          }
          (active||rep).innerHTML = sanitizeRichHtml((active||rep).innerHTML);
          return;
        }

        if(!cmd) return;

        if(cmd === 'clear'){
          try{ exec('removeFormat'); }catch(_e){}
          try{ exec('unlink'); }catch(_e2){}
        }else if(cmd === 'p'){
          exec('formatBlock', 'P');
        }else if(cmd === 'ul'){
          exec('insertUnorderedList');
        }else if(cmd === 'ol'){
          exec('insertOrderedList');
        }else if(cmd === 'quote'){
          exec('formatBlock', 'BLOCKQUOTE');
        }else if(cmd === 'hr'){
          exec('insertHorizontalRule');
        }else if(cmd === 'h1' || cmd === 'h2' || cmd === 'h3'){
          exec('formatBlock', cmd.toUpperCase());
        }else if(cmd === 'createLink'){
          var url = prompt('Enter link URL (https://...)');
          if(url) exec('createLink', url);
        }else if(cmd === 'insertImage'){
          var img = prompt('Enter image URL (https://...)');
          if(img) exec('insertImage', img);
        }else if(cmd === 'justifyLeft' || cmd === 'justifyCenter' || cmd === 'justifyRight' || cmd === 'justifyFull'){
          exec(cmd);
        }else if(cmd === 'bold' || cmd === 'italic' || cmd === 'underline' || cmd === 'strikeThrough'){
          exec(cmd);
        }else{
          // fallback
          exec(cmd, wval || null);
        }

        (active||rep).innerHTML = sanitizeRichHtml((active||rep).innerHTML);
      });

      var headingEl = toolbar.querySelector('#slbCmrMyHeading');
      var sizeEl = toolbar.querySelector('#slbCmrMySize');
      var colorEl = toolbar.querySelector('#slbCmrMyColor');
      var hlEl = toolbar.querySelector('#slbCmrMyHl');

      if(headingEl){
        headingEl.addEventListener('change', function(){
          var v = String(headingEl.value||'p');
          restoreRange();
          focus();
          if(v === 'p') exec('formatBlock', 'P');
          else exec('formatBlock', v.toUpperCase());
          (active||rep).innerHTML = sanitizeRichHtml((active||rep).innerHTML);
        });
      }

      if(sizeEl){
        sizeEl.addEventListener('change', function(){
          var px = String(sizeEl.value||'').trim();
          if(!px) return;
          restoreRange();
          focus();
          if(!wrapSelection('font-size:' + px + 'px;')){
            // fallback
            try{ document.execCommand('fontSize', false, '7'); }catch(_e){}
            try{
              var fontElements = (active||rep).getElementsByTagName('font');
              for(var i=0;i<fontElements.length;i++){
                if(fontElements[i].size == '7'){
                  fontElements[i].removeAttribute('size');
                  fontElements[i].style.fontSize = px + 'px';
                }
              }
            }catch(_e2){}
          }
          (active||rep).innerHTML = sanitizeRichHtml((active||rep).innerHTML);
        });
      }

      if(colorEl){
        colorEl.addEventListener('input', function(){
          var c = String(colorEl.value||'').trim();
          if(!c) return;
          restoreRange();
          focus();
          if(!wrapSelection('color:' + c + ';')){
            try{ document.execCommand('foreColor', false, c); }catch(_e){}
          }
          (active||rep).innerHTML = sanitizeRichHtml((active||rep).innerHTML);
        });
      }

      if(hlEl){
        hlEl.addEventListener('input', function(){
          var c = String(hlEl.value||'').trim();
          if(!c) return;
          restoreRange();
          focus();
          if(!wrapSelection('background-color:' + c + ';')){
            try{ document.execCommand('hiliteColor', false, c); }catch(_e){
              try{ document.execCommand('backColor', false, c); }catch(_e2){}
            }
          }
          (active||rep).innerHTML = sanitizeRichHtml((active||rep).innerHTML);
        });
      }
    }

    // Provide external API
    return {
      setReportHtml: function(h){ rep.innerHTML = sanitizeRichHtml(String(h||'')); },
      getReportHtml: function(){ return sanitizeRichHtml(rep.innerHTML || ''); },
      getReportText: function(){ return htmlToText(rep.innerHTML || ''); },
      focusReport: function(){ try{ rep.focus(); setActive(rep); }catch(_e){} },

      setNotesHtml: function(h){ not.innerHTML = sanitizeRichHtml(String(h||'')); },
      getNotesHtml: function(){ return sanitizeRichHtml(not.innerHTML || ''); },
      getNotesText: function(){ return htmlToText(not.innerHTML || ''); },
      focusNotes: function(){ try{ not.focus(); setActive(not); }catch(_e){} }
    };

    // ---- toolbar html builder (unique ids) ----
    function cmrFullToolbarHtml_(prefix){
      // prefix is unused here for now; keep signature in case we extend.
      return `
        <div class="slbWysRow">
          <div class="slbWysGroup">
            <select id="slbCmrMyHeading" class="slbWysSel" title="Heading">
              <option value="p" selected>Paragraph</option>
              <option value="h1">H1</option>
              <option value="h2">H2</option>
              <option value="h3">H3</option>
              <option value="quote">Quote</option>
            </select>
            <select id="slbCmrMySize" class="slbWysSel" title="Font size">
              <option value="12">12</option>
              <option value="14" selected>14</option>
              <option value="16">16</option>
              <option value="18">18</option>
              <option value="20">20</option>
              <option value="24">24</option>
              <option value="28">28</option>
              <option value="32">32</option>
            </select>
          </div>

          <div class="slbWysGroup">
            <button class="btn soft mini" type="button" data-wcmd="bold" title="Bold"><b>B</b></button>
            <button class="btn soft mini" type="button" data-wcmd="italic" title="Italic"><i>I</i></button>
            <button class="btn soft mini" type="button" data-wcmd="underline" title="Underline"><u>U</u></button>
            <button class="btn soft mini" type="button" data-wcmd="strikeThrough" title="Strike"><s>S</s></button>
          </div>

          <div class="slbWysGroup">
            <button class="btn soft mini" type="button" data-wcmd="justifyLeft" title="Align left">⟸</button>
            <button class="btn soft mini" type="button" data-wcmd="justifyCenter" title="Align center">≡</button>
            <button class="btn soft mini" type="button" data-wcmd="justifyRight" title="Align right">⟹</button>
            <button class="btn soft mini" type="button" data-wcmd="justifyFull" title="Justify">☰</button>
          </div>

          <div class="slbWysGroup">
            <button class="btn soft mini" type="button" data-wcmd="ul" title="Bullet list">•</button>
            <button class="btn soft mini" type="button" data-wcmd="ol" title="Number list">1.</button>
            <button class="btn soft mini" type="button" data-wcmd="hr" title="Line">―</button>
            <button class="btn soft mini" type="button" data-wcmd="createLink" title="Link">🔗</button>
            <button class="btn soft mini" type="button" data-wcmd="insertImage" title="Image">🖼</button>
          </div>

          <div class="slbWysGroup">
            <div class="slbEmojiWrap">
              <button class="btn soft mini" type="button" data-wcmd="emoji" title="Emoji">😊</button>
              <div class="slbEmojiPanel hidden">
                <div class="slbEmojiGrid">
                  <button type="button" class="slbEmoji" data-emoji="😀">😀</button>
                  <button type="button" class="slbEmoji" data-emoji="😄">😄</button>
                  <button type="button" class="slbEmoji" data-emoji="😅">😅</button>
                  <button type="button" class="slbEmoji" data-emoji="😉">😉</button>
                  <button type="button" class="slbEmoji" data-emoji="😊">😊</button>
                  <button type="button" class="slbEmoji" data-emoji="🙏">🙏</button>
                  <button type="button" class="slbEmoji" data-emoji="🔥">🔥</button>
                  <button type="button" class="slbEmoji" data-emoji="⚡">⚡</button>
                  <button type="button" class="slbEmoji" data-emoji="✅">✅</button>
                  <button type="button" class="slbEmoji" data-emoji="❗">❗</button>
                </div>
              </div>
            </div>
            <button class="btn soft mini" type="button" data-wcmd="clear" title="Clear formatting">Clear</button>
          </div>
        </div>

        <div class="slbWysRow">
          <div class="slbWysGroup">
            <span class="muted" style="font-size:12px;font-weight:900;">Text</span>
            <input id="slbCmrMyColor" type="color" class="slbWysColor" title="Text color" />
            <button class="slbSwatch" type="button" data-wcolor="#000000" style="--c:#000000" title="#000"></button>
            <button class="slbSwatch" type="button" data-wcolor="#ef5e14" style="--c:#ef5e14" title="Tin Yat Orange"></button>
            <button class="slbSwatch" type="button" data-wcolor="#0f1517" style="--c:#0f1517" title="Charcoal"></button>
            <button class="slbSwatch" type="button" data-wcolor="#7c3aed" style="--c:#7c3aed" title="Purple"></button>
            <button class="slbSwatch" type="button" data-wcolor="#2563eb" style="--c:#2563eb" title="Blue"></button>
          </div>

          <div class="slbWysGroup">
            <span class="muted" style="font-size:12px;font-weight:900;">HL</span>
            <input id="slbCmrMyHl" type="color" class="slbWysColor" title="Highlight" />
            <button class="slbSwatch" type="button" data-wbg="#fff3b0" style="--c:#fff3b0" title="Yellow"></button>
            <button class="slbSwatch" type="button" data-wbg="#dbeafe" style="--c:#dbeafe" title="Blue"></button>
            <button class="slbSwatch" type="button" data-wbg="#dcfce7" style="--c:#dcfce7" title="Green"></button>
            <button class="slbSwatch" type="button" data-wbg="#fee2e2" style="--c:#fee2e2" title="Red"></button>
            <button class="slbSwatch" type="button" data-wbg="#f3e8ff" style="--c:#f3e8ff" title="Purple"></button>
          </div>
        </div>
      `;
    }
  }


  // ===== Inbox-style Rich Editor (clone Diary Inbox toolbar exactly) =====
  // Used by User CMR -> Medical Records editor, to match the CMR INBOX editor UI.
  function sanitizeRichHtml(html){
    html = String(html||'');
    // remove script/style
    html = html.replace(/<(script|style)[^>]*>[\s\S]*?<\/\1>/gi,'');
    // strip event handlers
    html = html.replace(/\son\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi,'');
    // keep basic tags
    var allowed = /^(BR|P|DIV|SPAN|B|STRONG|I|EM|U|S|UL|OL|LI|H1|H2|H3|H4|BLOCKQUOTE)$/;
    // convert unknown tags to spans
    html = html.replace(/<\/?([a-z0-9]+)([^>]*)>/gi, function(m, tag, attrs){
      tag = String(tag||'').toUpperCase();
      if(tag === 'A'){
        // Strip links (avoid phishing in internal tools)
        return (m[1] === '/' ? '' : '');
      }
      if(!allowed.test(tag)){
        if(m.startsWith('</')) return '';
        return '<span>';
      }
      if(m.startsWith('</')) return '</' + tag.toLowerCase() + '>';

      // keep only style for span/div/p/h*
      var style = '';
      var m2 = String(attrs||'').match(/style\s*=\s*("[^"]*"|'[^']*')/i);
      if(m2){
        style = m2[1];
        // allow only color/background/text-align/font-weight/font-style/text-decoration
        var st = style.slice(1,-1);
        var keep = [];
        st.split(';').forEach(function(p){
          p = String(p||'').trim();
          if(!p) return;
          var kv = p.split(':');
          if(kv.length < 2) return;
          var k = String(kv[0]||'').trim().toLowerCase();
          var v = String(kv.slice(1).join(':')||'').trim();
          if(!v) return;
          if(k === 'color' || k === 'background-color' || k === 'text-align' || k === 'font-weight' || k === 'font-style' || k === 'text-decoration'){
            keep.push(k + ':' + v);
          }
        });
        if(keep.length) style = ' style="' + keep.join(';') + '"'; else style = '';
      }
      return '<' + tag.toLowerCase() + style + '>';
    });
    // fix stray <span> from unknown tag conversion
    html = html.replace(/<span>\s*<\/span>/g,'');
    return html;
  }

  function htmlToText(html){
    html = String(html||'');
    html = html.replace(/<br\s*\/?\s*>/gi,'\n');
    html = html.replace(/<\/?p[^>]*>/gi,'\n');
    html = html.replace(/<\/?div[^>]*>/gi,'\n');
    html = html.replace(/<[^>]+>/g,'');
    // decode minimal entities
    html = html.replace(/&nbsp;/g,' ')
      .replace(/&amp;/g,'&')
      .replace(/&lt;/g,'<')
      .replace(/&gt;/g,'>')
      .replace(/&quot;/g,'"')
      .replace(/&#39;/g,"'");
    return html.replace(/\n{3,}/g,'\n\n').trim();
  }

  function wordCount(t){
    t = String(t||'').trim();
    if(!t) return 0;
    return t.split(/\s+/).filter(Boolean).length;
  }


  // Inbox/Diary-style rich editor wiring for multiple contenteditable boxes.
  // Must match the toolbar markup cloned from #slbDiWysToolbar (see snippets/saamlawbank-app.liquid).
  function installRichEditorMulti(opts){
    var toolbar = opts.toolbarEl;
    var editors = opts.editors || [];
    if(!toolbar || !editors || !editors.length){
      return {
        getActive: function(){ return (editors && editors[0]) ? editors[0] : null; },
        setActive: function(){} ,
        getHtml: function(){ return ''; },
        setHtml: function(){}
      };
    }

    // Toolbar controls (IDs must match the cloned diary toolbar template)
    var headingEl = toolbar.querySelector('#slbDiHeading');
    var sizeEl = toolbar.querySelector('#slbDiWysSize');
    var colorEl = toolbar.querySelector('#slbDiWysColor');
    var hlEl = toolbar.querySelector('#slbDiWysHl');

    var activeEditor = editors[0];
    var savedRange = null;

    function focus(){
      try{ if(activeEditor) activeEditor.focus(); }catch(_e){}
    }

    function saveRange(){
      try{
        var sel = window.getSelection ? window.getSelection() : null;
        if(!sel || sel.rangeCount === 0) return;
        var r = sel.getRangeAt(0);
        if(activeEditor && activeEditor.contains(r.commonAncestorContainer)){
          savedRange = r.cloneRange();
        }
      }catch(_e){}
    }

    function restoreRange(){
      try{
        if(!savedRange) return;
        var sel = window.getSelection ? window.getSelection() : null;
        if(!sel) return;
        sel.removeAllRanges();
        sel.addRange(savedRange);
      }catch(_e){}
    }

    function exec(cmd, val){
      try{ document.execCommand('styleWithCSS', false, true); }catch(_e){}
      try{ document.execCommand(cmd, false, val); }catch(_e2){}
    }

    function wrapSelection(style){
      try{
        var sel = window.getSelection ? window.getSelection() : null;
        if(!sel || sel.rangeCount === 0) return false;
        var range = sel.getRangeAt(0);
        if(!activeEditor || !activeEditor.contains(range.commonAncestorContainer)) return false;
        if(range.collapsed) return false;

        var span = document.createElement('span');
        span.setAttribute('style', style);
        try{
          var contents = range.extractContents();
          span.appendChild(contents);
          range.insertNode(span);
          range.selectNodeContents(span);
          sel.removeAllRanges();
          sel.addRange(range);
          savedRange = range.cloneRange();
          return true;
        }catch(_e){
          return false;
        }
      }catch(_e2){
        return false;
      }
    }

    function safeUrl(u){
      u = String(u || '').trim();
      if(!u) return '';
      var lower = u.toLowerCase();
      if(lower.indexOf('javascript:') === 0) return '';
      if(lower.indexOf('data:') === 0) return '';
      if(lower.indexOf('vbscript:') === 0) return '';
      if(lower.indexOf('http://') === 0 || lower.indexOf('https://') === 0) return u;
      // allow protocol-relative
      if(lower.indexOf('//') === 0) return 'https:' + u;
      return '';
    }

    // Emoji picker helpers
    var emojiDocBound = false;
    function closeEmoji_(){
      try{ toolbar.querySelectorAll('.slbEmojiPanel').forEach(function(p){ p.classList.add('hidden'); }); }catch(_e){}
    }
    function toggleEmoji_(btn){
      try{
        var wrap = btn && btn.closest ? btn.closest('.slbEmojiWrap') : null;
        var panel = wrap ? wrap.querySelector('.slbEmojiPanel') : null;
        if(!panel){ closeEmoji_(); return; }
        var wasOpen = !panel.classList.contains('hidden');
        closeEmoji_();
        if(wasOpen) return;
        panel.classList.remove('hidden');
        if(!emojiDocBound){
          emojiDocBound = true;
          document.addEventListener('click', function(e){
            try{
              if(!toolbar.contains(e.target)) return closeEmoji_();
              var w = e.target && e.target.closest ? e.target.closest('.slbEmojiWrap') : null;
              if(!w) closeEmoji_();
            }catch(_e2){}
          }, true);
        }
      }catch(_e){}
    }

    function bindEditor(editor){
      editor.addEventListener('focus', function(){ activeEditor = editor; });
      editor.addEventListener('mouseup', function(){ activeEditor = editor; saveRange(); });
      editor.addEventListener('keyup', function(){ activeEditor = editor; saveRange(); });
      editor.addEventListener('input', function(){
        // DO NOT rewrite innerHTML on every keystroke (it resets caret).
        activeEditor = editor;
        saveRange();
      });
      editor.addEventListener('keydown', function(e){
        if(!(e.ctrlKey || e.metaKey)) return;
        var k = String(e.key||'').toLowerCase();
        if(k !== 'b' && k !== 'i' && k !== 'u') return;
        e.preventDefault();
        try{ saveRange(); }catch(_e){}
        try{ restoreRange(); }catch(_e2){}
        focus();
        if(k === 'b') exec('bold');
        else if(k === 'i') exec('italic');
        else exec('underline');
      });
      editor.addEventListener('paste', function(e){
        // Allow rich paste (sanitized). Fallback to plain text.
        activeEditor = editor;
        var html = '';
        var text = '';
        try{
          var cd = (e.clipboardData || window.clipboardData);
          if(cd){
            html = cd.getData('text/html') || '';
            text = cd.getData('text/plain') || '';
          }
        }catch(_e){ html=''; text=''; }
        if(!html && !text) return;

        e.preventDefault();
        restoreRange();
        focus();

        if(html){
          var safe = '';
          try{ safe = sanitizeRichHtml(html); }catch(_e2){ safe = ''; }
          if(safe){
            try{ document.execCommand('insertHTML', false, safe); return; }
            catch(_e3){
              try{ exec('insertText', htmlToText(safe)); return; }catch(_e4){}
            }
          }
        }

        var t = String(text||'');
        try{ document.execCommand('insertText', false, t); }
        catch(_e5){ exec('insertText', t); }
      });
    }
    editors.forEach(bindEditor);

    if(toolbar){
      // Save range before toolbar interactions steal focus
      toolbar.addEventListener('mousedown', function(ev){
        var t = ev.target && ev.target.closest ? ev.target.closest('button,select,input') : null;
        if(t){
          saveRange();
          try{ if(t.tagName === 'BUTTON') ev.preventDefault(); }catch(_e){}
        }
      });

      toolbar.addEventListener('click', function(ev){
        var btn = ev.target && ev.target.closest ? ev.target.closest('button') : null;
        if(!btn) return;

        var wcolor = btn.getAttribute('data-wcolor');
        var wbg = btn.getAttribute('data-wbg');
        var emoji = btn.getAttribute('data-emoji');
        var cmd = String(btn.getAttribute('data-wcmd')||'');
        var wval = btn.getAttribute('data-wval');

        if(emoji){
          restoreRange();
          focus();
          closeEmoji_();
          exec('insertText', String(emoji));
          return;
        }

        if(cmd === 'emoji'){
          ev.preventDefault();
          toggleEmoji_(btn);
          return;
        }

        closeEmoji_();
        restoreRange();
        focus();

        if(wcolor){
          var c1 = String(wcolor||'').trim();
          if(!c1) return;
          if(!wrapSelection('color:' + c1 + ';')){
            exec('foreColor', c1);
            try{ activeEditor.innerHTML = sanitizeRichHtml(activeEditor.innerHTML); }catch(_e3){}
          }
          return;
        }

        if(wbg){
          var c2 = String(wbg||'').trim();
          if(!c2) return;
          if(!wrapSelection('background-color:' + c2 + ';')){
            try{ document.execCommand('hiliteColor', false, c2); }
            catch(_e2){ try{ document.execCommand('backColor', false, c2); }catch(_e3){} }
            try{ activeEditor.innerHTML = sanitizeRichHtml(activeEditor.innerHTML); }catch(_e4){}
          }
          return;
        }

        if(!cmd) return;

        if(cmd === 'formatBlock' && wval){
          // Toolbar provides BLOCKQUOTE, etc.
          exec('formatBlock', wval);
          return;
        }

        if(cmd === 'createLink'){
          var u1 = prompt('Link URL (https://...)');
          var su1 = safeUrl(u1);
          if(!su1) return;
          exec('createLink', su1);
          return;
        }

        if(cmd === 'insertImage'){
          var u2 = prompt('Image URL (https://...)');
          var su2 = safeUrl(u2);
          if(!su2) return;
          exec('insertImage', su2);
          return;
        }

        exec(cmd);
      });
    }

    if(colorEl){
      colorEl.addEventListener('mousedown', saveRange);
      colorEl.addEventListener('change', function(){
        restoreRange();
        focus();
        var c = String(colorEl.value||'').trim();
        if(!c) return;
        if(!wrapSelection('color:' + c + ';')){
          exec('foreColor', c);
          try{ activeEditor.innerHTML = sanitizeRichHtml(activeEditor.innerHTML); }catch(_e3){}
        }
      });
    }

    if(hlEl){
      hlEl.addEventListener('mousedown', saveRange);
      hlEl.addEventListener('change', function(){
        restoreRange();
        focus();
        var c = String(hlEl.value||'').trim();
        if(!c) return;
        if(!wrapSelection('background-color:' + c + ';')){
          try{ document.execCommand('hiliteColor', false, c); }
          catch(_e2){ try{ document.execCommand('backColor', false, c); }catch(_e3){} }
          try{ activeEditor.innerHTML = sanitizeRichHtml(activeEditor.innerHTML); }catch(_e4){}
        }
      });
    }

    if(sizeEl){
      sizeEl.addEventListener('mousedown', saveRange);
      sizeEl.addEventListener('change', function(){
        restoreRange();
        focus();
        var n = Number(String(sizeEl.value||'').trim());
        if(!n) return;
        var px = Math.max(8, Math.min(48, Math.round(n)));
        if(!wrapSelection('font-size:' + px + 'px;')){
          // fallback: apply a generic large size; sanitize may keep inline styles
          try{ document.execCommand('fontSize', false, '7'); }catch(_e2){}
          try{ activeEditor.innerHTML = sanitizeRichHtml(activeEditor.innerHTML); }catch(_e3){}
        }
      });
    }

    if(headingEl){
      headingEl.addEventListener('mousedown', saveRange);
      headingEl.addEventListener('change', function(){
        restoreRange();
        focus();
        var v = String(headingEl.value||'').trim();
        if(!v) return;
        if(v === 'p') exec('formatBlock', 'P');
        else if(v === 'h1') exec('formatBlock','H1');
        else if(v === 'h2') exec('formatBlock','H2');
        else if(v === 'h3') exec('formatBlock','H3');
        else if(v === 'h4') exec('formatBlock','H4');
        else exec('formatBlock','P');
      });
    }

    return {
      getActive: function(){ return activeEditor; },
      setActive: function(el){ if(el) activeEditor = el; },
      getHtml: function(){ return sanitizeRichHtml(activeEditor ? activeEditor.innerHTML : ''); },
      setHtml: function(html){ if(activeEditor) activeEditor.innerHTML = sanitizeRichHtml(html||''); }
    };
  }
  function cloneDiaryToolbar_(targetEl){
    try{
      var src = document.getElementById('slbDiWysToolbar');
      if(!src || !targetEl) return false;
      targetEl.innerHTML = src.innerHTML;
      return true;
    }catch(_e){
      return false;
    }
  }

  function wireDiaryCloneDualEditor_(opts){
    opts = opts||{};
    var toolbarEl = document.getElementById(opts.toolbarId||'');
    var rep = document.getElementById(opts.reportId||'');
    var not = document.getElementById(opts.notesId||'');
    if(!toolbarEl || !rep || !not) return null;

    if(!toolbarEl.dataset) toolbarEl.dataset = {};
    if(toolbarEl.dataset.filled !== '1'){
      toolbarEl.dataset.filled = '1';
      // Fill from Diary Inbox toolbar template
      cloneDiaryToolbar_(toolbarEl);
    }

    // Install toolbar behavior
    installRichEditorMulti({ toolbarEl: toolbarEl, editors: [rep, not] });

    // Word counters
    var wc1 = opts.wc1Id ? document.getElementById(opts.wc1Id) : null;
    var wc2 = opts.wc2Id ? document.getElementById(opts.wc2Id) : null;
    function updateCounters(){
      try{
        if(wc1) wc1.textContent = wordCount(htmlToText(rep.innerHTML||'')) + ' words';
        if(wc2) wc2.textContent = wordCount(htmlToText(not.innerHTML||'')) + ' words';
      }catch(_e){}
    }
    rep.addEventListener('input', updateCounters);
    not.addEventListener('input', updateCounters);
    updateCounters();

    return {
      setReportHtml: function(h){ rep.innerHTML = sanitizeRichHtml(String(h||'')); updateCounters(); },
      getReportHtml: function(){ return sanitizeRichHtml(rep.innerHTML || ''); },
      getReportText: function(){ return htmlToText(rep.innerHTML || ''); },
      focusReport: function(){ try{ rep.focus(); }catch(_e){} },

      setNotesHtml: function(h){ not.innerHTML = sanitizeRichHtml(String(h||'')); updateCounters(); },
      getNotesHtml: function(){ return sanitizeRichHtml(not.innerHTML || ''); },
      getNotesText: function(){ return htmlToText(not.innerHTML || ''); },
      focusNotes: function(){ try{ not.focus(); }catch(_e){} }
    };
  }


  injectStyleOnce('slbCmrCss', `
    .slbCmrGrid{display:grid;grid-template-columns:280px 1fr;gap:12px;align-items:start;margin-top:12px;}
    @media (max-width: 980px){ .slbCmrGrid{grid-template-columns:1fr;} }
    .slbCmrLeft{border:1px solid var(--border);border-radius:14px;overflow:hidden;background:rgba(255,255,255,.02);}
    .slbCmrLeftTop{padding:10px;border-bottom:1px solid var(--border);display:flex;gap:10px;align-items:center;flex-wrap:wrap;}
    .slbCmrSearch{flex:1;min-width:220px;padding:10px 12px;border:1px solid var(--border);border-radius:12px;background:rgba(255,255,255,.02);color:var(--text);outline:none;}
    .slbCmrList{max-height:560px;overflow:auto;}

    .slbCmrMyList{max-height:280px;overflow:auto;}
    .slbCmrMyRowTop{display:flex;gap:10px;align-items:baseline;}
    .slbCmrMyRowWhen{font-weight:1000;min-width:0;}
    .slbCmrMyRowPv{margin-left:auto;max-width:58%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--muted);font-size:12px;text-align:right;}
    @media (max-width:640px){.slbCmrMyRowTop{flex-direction:column;gap:2px;align-items:flex-start;}.slbCmrMyRowPv{max-width:100%;text-align:left;}}
    /* Global zebra: match SLB standard (ty-surface-2/3, ty-hover/active) */
    .slbCmrRow{padding:10px 12px;border-bottom:1px solid var(--border);cursor:pointer;display:flex;justify-content:space-between;gap:10px;background:var(--ty-surface-2, rgba(239,94,20,.02));}
    #slbCmrMyList .slbCmrRow{border-bottom:none;}
    .slbCmrRow:hover{background:var(--ty-hover, rgba(239,94,20,.08));}
    .slbCmrRow.is-active{background:var(--ty-active, rgba(239,94,20,.14)) !important;}
    #slbCmrMyList .slbCmrRow:nth-child(even),
    #slbCmrList .slbCmrRow:nth-child(even),
    #slbCmrAdmEntries .slbCmrRow:nth-child(even){background:var(--ty-surface-3, rgba(239,94,20,.035));}
    .slbCmrMeta{font-size:12px;color:var(--muted);}
    .slbCmrRight{border:1px solid var(--border);border-radius:14px;overflow:hidden;}
    .slbCmrViewerTop{padding:10px 12px;border-bottom:1px solid var(--border);display:flex;align-items:center;justify-content:space-between;gap:10px;flex-wrap:wrap;}
    .slbCmrViewerBody{padding:12px;}
    .slbCmrReport{border:1px solid var(--border);border-radius:12px;padding:12px;background:rgba(255,255,255,.02);line-height:1.5;}
    .slbCmrEd{margin-top:12px;border:1px solid var(--border);border-radius:12px;overflow:hidden;background:rgba(255,255,255,.02);}
    .slbCmrEdTop{padding:8px 10px;border-bottom:1px solid var(--border);display:flex;justify-content:flex-start;align-items:center;gap:10px;flex-wrap:wrap;}
    .slbCmrEdLabel{font-weight:800;}
    .slbCmrEdBtns{display:flex;gap:6px;align-items:center;flex-wrap:wrap;}
    .slbCmrEdBox{min-height:120px;padding:10px 12px;outline:none;}
    .slbCmrEdBox:empty:before{content:attr(data-placeholder);color:var(--muted);}
    .slbCmrEdDual{padding:10px 10px 12px;}
    .slbCmrEdSubLabel{font-size:12px;color:var(--muted);font-weight:900;margin:2px 2px 6px;}
    .slbCmrEdBoxTall{min-height:220px;height:260px;max-height:260px;overflow:auto;border:1px solid var(--border);border-radius:12px;background:rgba(255,255,255,.02);}
    .slbCmrEdBoxSmall{min-height:90px;height:120px;max-height:140px;overflow:auto;border:1px solid var(--border);border-radius:12px;background:rgba(255,255,255,.02);}
    .slbCmrViewerActions{display:flex;justify-content:flex-end;gap:8px;flex-wrap:wrap;margin-top:10px;}
    .slbCmrSmallNote{font-size:12px;color:var(--muted);}
    .slbCmrSplitBtns{display:flex;gap:8px;align-items:center;flex-wrap:wrap;}
    .slbCmrAcc{display:flex;flex-direction:column;gap:12px;margin-top:2px;}
    /* IMPORTANT: use theme vars so dark mode never becomes white */
    .slbCmrDetails{border:none;border-radius:14px;overflow:hidden;background:var(--slb-panel,#fff);}
    .slbCmrSummary{list-style:none;cursor:pointer;display:flex;align-items:center;justify-content:space-between;gap:10px;padding:12px 12px;font-weight:1000;;background:var(--ty-grey-ui, rgba(15,21,23,.10));}
    .slbCmrSummary::-webkit-details-marker{display:none;}
    .slbCmrSumLeft{display:flex;flex-direction:column;gap:2px;min-width:0;}
    .slbCmrSumTitle{font-size:14px;font-weight:1100;letter-spacing:.2px;}
    .slbCmrSumSub{font-size:12px;font-weight:800;color:var(--muted);}
    .slbCmrSumRight{display:flex;align-items:center;gap:10px;}
    .slbCmrOpenPill{padding:6px 10px;border:1px solid var(--border);border-radius:999px;font-size:12px;font-weight:1000;opacity:.92;}
    .slbCmrIconBtn{width:34px;height:34px;border-radius:999px;border:1px solid var(--border);background:transparent;color:var(--text);cursor:pointer;font-weight:1100;display:flex;align-items:center;justify-content:center;line-height:1;}
    .slbCmrIconBtn:hover{background:rgba(239,94,20,.08);}
    .slbCmrIconBtn:disabled{opacity:.55;cursor:not-allowed;}
    .slbCmrBody{padding:12px;}

  
#slbCmrPanel .slbCmrOut{margin-top:12px;}
#slbCmrPanel .slbCmrNotesText{
  width:100%;
  min-height:90px;
  resize:vertical;
  border-radius:16px;
  border:1px solid rgba(15,21,23,.14);
  padding:12px 14px;
  font-size:14px;
  line-height:1.25;
  background:#fff;
}
#slbCmrPanel .slbCmrBtnRow{
  display:flex;
  align-items:center;
  justify-content:center;
  gap:10px;
  flex-wrap:wrap;
  margin:10px 0;
}
#slbCmrPanel .slbCmrTagRow{margin:10px 0;}
#slbCmrPanel .slbCmrTagInput{
  width:100%;
  border-radius:16px;
  border:1px solid rgba(15,21,23,.14);
  padding:12px 14px;
  font-size:14px;
  line-height:1.25;
  background:#fff;
}
#slbCmrPanel .slbCmrSaveRow{margin-top:12px;}
#slbCmrPanel .slbCmrBtnRow .btn{
  min-width:120px;
  padding:12px 18px;
  border-radius:999px;
  border:1px solid rgba(15,21,23,.14);
  background:#fff;
  color:#0f1517;
  font-weight:1000;
  letter-spacing:.2px;
}
#slbCmrPanel .slbCmrBtnRow .btn:hover{background:rgba(239,94,20,.06);}
#slbCmrPanel .slbCmrBtnRow .btn.primary{ background:var(--slb-action-orange-bg,var(--ty-orange,#ef5e14)); border-color:var(--slb-action-orange-border,var(--ty-orange,#ef5e14)); color:#fff; box-shadow:var(--slb-action-orange-shadow,none); }
#slbCmrPanel .slbCmrBtnRow .btn.email,
#slbCmrPanel .slbCmrBtnRow .btn.danger{ background:#b42318; border-color:#b42318; color:#fff; }
#slbCmrPanel .slbCmrBtnRow .btn:disabled{opacity:.55;cursor:not-allowed;}

/* ===== Dark-mode overrides (User CMR) ===== */
:root[data-slb-theme="dark"] #slbCmrPanel .slbCmrDetails{ background: var(--slb-panel, #0f1517) !important; }
:root[data-slb-theme="dark"] #slbCmrPanel .slbCmrSummary{ background: var(--slb-panel-2, #151c20) !important; color: var(--slb-text, #e8eef2) !important; }
:root[data-slb-theme="dark"] #slbCmrPanel .slbCmrBody{ color: var(--slb-text, #e8eef2) !important; }
:root[data-slb-theme="dark"] #slbCmrPanel .slbCmrNotesText,
:root[data-slb-theme="dark"] #slbCmrPanel .slbCmrTagInput,
:root[data-slb-theme="dark"] #slbCmrPanel .slbCmrSearch{
  background: var(--slb-panel-2, #151c20) !important;
  color: var(--slb-text, #e8eef2) !important;
  border-color: var(--slb-border, rgba(255,255,255,.14)) !important;
}
:root[data-slb-theme="dark"] #slbCmrPanel .slbCmrBtnRow .btn{
  background: var(--slb-panel-2, #151c20) !important;
  color: var(--slb-text, #e8eef2) !important;
  border-color: var(--slb-border, rgba(255,255,255,.14)) !important;
}
:root[data-slb-theme="dark"] #slbCmrPanel .slbCmrBtnRow .btn.primary{
  background:var(--slb-action-orange-bg,var(--ty-orange,#ef5e14)) !important;
  border-color:var(--slb-action-orange-border,var(--ty-orange,#ef5e14)) !important;
  color:#fff !important;
  box-shadow:var(--slb-action-orange-shadow,none) !important;
}
:root[data-slb-theme="dark"] #slbCmrPanel .slbCmrBtnRow .btn.email,
:root[data-slb-theme="dark"] #slbCmrPanel .slbCmrBtnRow .btn.danger{
  background:#b42318 !important;
  border-color:#b42318 !important;
  color:#fff !important;
}
:root[data-slb-theme="dark"] #slbCmrPanel .slbCmrLeft,
:root[data-slb-theme="dark"] #slbCmrPanel .slbCmrRight{ background: var(--slb-panel, #0f1517) !important; }
:root[data-slb-theme="dark"] #slbCmrPanel .slbCmrViewerTop{ background: var(--slb-panel, #0f1517) !important; color: var(--slb-text, #e8eef2) !important; }
:root[data-slb-theme="dark"] #slbCmrPanel .slbCmrReport,
:root[data-slb-theme="dark"] #slbCmrPanel .slbCmrEd,
:root[data-slb-theme="dark"] #slbCmrPanel .slbCmrEdBoxTall,
:root[data-slb-theme="dark"] #slbCmrPanel .slbCmrEdBoxSmall{
  background: var(--slb-panel-2, #151c20) !important;
  color: var(--slb-text, #e8eef2) !important;
  border-color: var(--slb-border, rgba(255,255,255,.14)) !important;
}
/* Zebra for Records list */
:root[data-slb-theme="dark"] #slbCmrPanel .slbCmrRow{ background: var(--slb-zebra-a, rgba(255,255,255,.03)) !important; }
:root[data-slb-theme="dark"] #slbCmrPanel #slbCmrMyList .slbCmrRow:nth-child(even),
:root[data-slb-theme="dark"] #slbCmrPanel #slbCmrList .slbCmrRow:nth-child(even),
:root[data-slb-theme="dark"] #slbCmrPanel #slbCmrAdmEntries .slbCmrRow:nth-child(even){
  background: var(--slb-zebra-b, rgba(255,255,255,.06)) !important;
}
:root[data-slb-theme="dark"] #slbCmrPanel .slbCmrRow:hover{ background: var(--slb-hover, rgba(239,94,20,.14)) !important; }
:root[data-slb-theme="dark"] #slbCmrPanel .slbCmrRow.is-active{ background: var(--slb-active, rgba(239,94,20,.22)) !important; }
/* ===== CMR: darken outer fold/wrapper (fix remaining white wrapper) ===== */
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbCmrPanel.card{
  background: rgba(21,29,32,0.92) !important;
  border-color: rgba(255,255,255,0.10) !important;
}
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbCmrPanel .slbFold{
  background: rgba(21,29,32,0.85) !important;
  border-color: rgba(255,255,255,0.10) !important;
}
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbCmrPanel .slbFoldBody{
  background: rgba(21,29,32,0.85) !important;
}

/* Fix header titles being black-on-black in dark mode */
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) :is(.slbFoldTitle,.slbCmrSumTitle,.slbDiaryReadTitle,.slbSwrViewerTitle,.slbBoardTitleOutside .slbBoardHLine){
  color: var(--slb-text, #e8eef2) !important;
}
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .slbFoldHeader{
  background: rgba(255,255,255,0.06) !important;
}

/* CMR: make CLEAR button grey (not black) */
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbCmrClear.btn{
  background: rgba(255,255,255,0.08) !important;
  border-color: rgba(255,255,255,0.14) !important;
  color: var(--slb-text, #e8eef2) !important;
}
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbCmrClear.btn:hover{
  background: rgba(255,255,255,0.11) !important;
}

/* Pulse tool (User CMR): dark cards + readable text
   NOTE: do NOT touch pulse read toggle colors (.tycm-toggle) */
:root[data-slb-theme="dark"] #tycmRoot{
  color: var(--slb-text, #e8eef2) !important;
}
:root[data-slb-theme="dark"] #tycmRoot .tycm-card{
  background: var(--slb-panel-2, #151c20) !important;
  border-color: var(--slb-border, rgba(255,255,255,.14)) !important;
  box-shadow: none !important;
}
:root[data-slb-theme="dark"] #tycmRoot :is(.tycm-card-title,.tycm-organ-name){
  color: var(--slb-text, #e8eef2) !important;
}
:root[data-slb-theme="dark"] #tycmRoot :is(.tycm-card-sub,.tycm-subgrid-title,.tycm-field-label,.tycm-check){
  color: var(--slb-muted, #aab4bc) !important;
}
:root[data-slb-theme="dark"] #tycmRoot .tycm-modeRow{
  background: rgba(255,255,255,.06) !important;
  border-color: var(--slb-border, rgba(255,255,255,.14)) !important;
}
:root[data-slb-theme="dark"] #tycmRoot .tycm-radio{
  color: var(--slb-muted, #aab4bc) !important;
}
:root[data-slb-theme="dark"] #tycmRoot .tycm-radio.active{
  background: rgba(255,255,255,.10) !important;
  color: var(--slb-text, #e8eef2) !important;
  box-shadow: none !important;
}
:root[data-slb-theme="dark"] #tycmRoot .tycm-input{
  background: rgba(0,0,0,.20) !important;
  color: var(--slb-text, #e8eef2) !important;
  border-color: var(--slb-border, rgba(255,255,255,.14)) !important;
}
:root[data-slb-theme="dark"] #tycmRoot .tycm-input::placeholder{ color: rgba(232,238,242,.55) !important; }

/* Make Pulse tool Clear button grey */
:root[data-slb-theme="dark"] #tycmRoot .tycm-btn-secondary{
  background: rgba(255,255,255,.08) !important;
  border-color: rgba(255,255,255,.14) !important;
  color: var(--slb-text, #e8eef2) !important;
}
:root[data-slb-theme="dark"] #tycmRoot .tycm-btn-secondary:hover{ background: rgba(255,255,255,.11) !important; }

`);

  // ===== Pulse tool injection =====
  var PULSE = {
    css: `/* ===== Scoped to this page only ===== */
  #tycmRoot.tycm-wrap{
    --ty-orange:#ef5e14;
    --ty-dark:#0f1517;
    --ty-light-bg:#f7f7f7;

    /* darker borders for clarity */
    --ty-border: rgba(15,21,23,.14);
    --ty-border-soft: rgba(15,21,23,.10);

    --ty-muted:#6b7680;

    max-width:100%;
    margin:0;
    padding:0;
    font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Arial,sans-serif;
    color:#1b1f24;
    line-height:1.55;
  }

  #tycmRoot *{ box-sizing:border-box; }

  #tycmRoot .tycm-hero{
    border:1px solid var(--ty-border);
    border-radius:18px;
    padding:16px 16px;
    background:linear-gradient(140deg, rgba(239,94,20,.12), rgba(15,21,23,.04));
    margin-bottom:14px;
  }
  #tycmRoot .tycm-hero h1{margin:0;font-size:19px;letter-spacing:.2px;color:var(--ty-dark);font-weight:1000;}
  #tycmRoot .tycm-hero .sub{margin-top:6px;font-size:13px;color:var(--ty-muted);}

  #tycmRoot .tycm-card{
    background:#fff;
    border:1px solid var(--ty-border-soft);
    border-radius:14px;
    padding:12px 12px 10px;
    margin:10px 0;
    box-shadow:0 10px 24px rgba(15,21,23,.06);
  }
  #tycmRoot .tycm-card-title{font-size:15px;font-weight:1000;color:var(--ty-dark);}
  #tycmRoot .tycm-card-sub{font-size:13px;color:var(--ty-muted);margin-top:4px;}

  #tycmRoot .tycm-subgrid-title{
    font-size:13px;
    color:var(--ty-muted);
    margin:12px 0 8px;
    border-top:1px solid var(--ty-border-soft);
    padding-top:10px;
    font-weight:900;
  }

  #tycmRoot .tycm-organ-name{
    font-size:14px;
    margin:12px 2px 6px;
    font-weight:1000;
    color:#20262c;
  }
  #tycmRoot .tycm-field-label{
    font-size:13px;
    color:var(--ty-muted);
    margin:8px 2px 6px;
    font-weight:900;
  }

  /* Inputs (new meta section) */
  #tycmRoot .tycm-input{
    width:100%;
    border-radius:12px;
    border:1px solid var(--ty-border);
    background:#fff;
    color:#1b1f24;
    padding:10px 12px;
    font-size:14px;
    outline:none;
  }
  #tycmRoot .tycm-input:focus{
    border-color:rgba(239,94,20,.75);
    box-shadow:0 0 0 3px rgba(239,94,20,.22);
  }

  /* Meta section layout (match SDR top style) */
  #tycmRoot .tycm-metaCard{
    border-radius:18px;
    padding:16px 16px;
    background:linear-gradient(140deg, rgba(239,94,20,.12), rgba(15,21,23,.04));
    border:1px solid var(--ty-border);
    margin-bottom:14px;
  }
  #tycmRoot .tycm-metaCard .tycm-card-title,
  #tycmRoot .tycm-metaCard .tycm-card-sub{ display:none; }


  /* Meta section layout */
  #tycmRoot .tycm-modeRow{
    display:flex;
    gap:0;
    margin-top:10px;
    background:rgba(15,21,23,.06);
    border:1px solid var(--ty-border-soft);
    border-radius:999px;
    padding:4px;
    overflow:hidden;
  }
  #tycmRoot .tycm-radio{
    position:relative;
    flex:1;
    display:flex;
    align-items:center;
    justify-content:center;
    padding:10px 12px;
    border:0;
    border-radius:999px;
    background:transparent;
    cursor:pointer;
    font-weight:1000;
    font-size:13px;
    user-select:none;
    color:var(--ty-dark);
  }
  #tycmRoot .tycm-radio.active{
    background:rgba(255,255,255,.88);
    box-shadow:0 10px 20px rgba(15,21,23,.08);
  }
  #tycmRoot .tycm-radio input{
    position:absolute;
    opacity:0;
    pointer-events:none;
  }
  #tycmRoot .tycm-metaGrid{
    display:grid;
    grid-template-columns:1fr 1fr;
    gap:12px;
    margin-top:12px;
  }
  #tycmRoot .tycm-metaGrid > div,
  #tycmRoot .tycm-metaFull{
    background:rgba(255,255,255,.96);
    border:1px solid var(--ty-border-soft);
    border-radius:14px;
    padding:12px 12px;
  }
  #tycmRoot .tycm-metaFull{ margin-top:12px; }

  @media (max-width:640px){
    #tycmRoot .tycm-metaGrid{ grid-template-columns:1fr; }
  }

  /* ===== Two-column layout (desktop) + swipe panels (mobile) ===== */
  #tycmRoot .tycm-hand-switch{
    display:none;
    gap:8px;
    margin:10px 0 8px;
  }
  #tycmRoot .tycm-hand-switch button{
    appearance:none !important;
    -webkit-appearance:none !important;
    border-radius:999px !important;
    border:1px solid var(--ty-border) !important;
    padding:10px 12px !important;
    font-size:13px !important;
    font-weight:1000 !important;
    cursor:pointer !important;
    background:#fff !important;
    color:var(--ty-dark) !important;
    flex:1 1 0;
    touch-action:manipulation;
    -webkit-tap-highlight-color:transparent;
  }
  #tycmRoot .tycm-hand-switch button.active{
    background:var(--slb-action-orange-bg,var(--ty-orange)) !important;
    border-color:var(--slb-action-orange-border,var(--ty-orange)) !important;
    color:#fff !important;
    box-shadow:var(--slb-action-orange-shadow,none) !important;
  }

  #tycmRoot .tycm-columns{
    display:grid;
    grid-template-columns:1fr 1fr;
    gap:12px;
    align-items:start;
  }
  #tycmRoot .tycm-col{min-width:0;}

  @media (max-width:860px){
    #tycmRoot .tycm-hand-switch{display:flex;}
    #tycmRoot .tycm-columns{
      display:flex;
      gap:12px;
      overflow-x:auto;
      scroll-snap-type:x mandatory;
      -webkit-overflow-scrolling:touch;
      padding-bottom:6px;
    }
    #tycmRoot .tycm-col{
      flex:0 0 92%;
      scroll-snap-align:start;
    }
  }

  /* ===== Fat toggle button (centered label + centered value) ===== */
  #tycmRoot .tycm-toggle{
    appearance:none !important;
    -webkit-appearance:none !important;
    width:100%;
    background:#ffffff !important;
    border:1px solid var(--ty-border) !important;
    color:#1b1f24 !important;
    border-radius:14px !important;
    padding:12px 12px !important;
    cursor:pointer !important;
    user-select:none;
    transition:transform .05s ease, border-color .15s ease, box-shadow .15s ease, background .15s ease;
    touch-action:manipulation;
    -webkit-tap-highlight-color:transparent;
    line-height:1.1 !important;
    box-shadow:none !important;
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
    gap:6px;
    min-height:62px;
  }
  #tycmRoot .tycm-toggle:active{transform:scale(0.99);}
  #tycmRoot .tycm-toggle:focus{
    outline:none !important;
    border-color:rgba(239,94,20,.8) !important;
    box-shadow:0 0 0 3px rgba(239,94,20,.22) !important;
  }

  #tycmRoot .tycm-toggle .k{
    font-weight:1000;
    color:var(--ty-muted);
    font-size:12px;
    letter-spacing:.2px;
    text-align:center;
  }
  #tycmRoot .tycm-toggle .v{
    font-weight:1100;
    font-size:14px;
    text-align:center;
    white-space:nowrap;
  }
  #tycmRoot .tycm-toggle .val{ color:var(--ty-dark); }
  #tycmRoot .tycm-toggle .hint{display:none !important;}


  /* Selected / set state */
  #tycmRoot .tycm-toggle.set{
    background:#ffffff !important;
    border-color:rgba(15,21,23,.20) !important;
  }
  #tycmRoot .tycm-toggle.set .k{ color:rgba(15,21,23,.70) !important; }
  #tycmRoot .tycm-toggle.set .val{ color:var(--ty-dark) !important; }

  /* 1-5 palette (Strength / Speed) */
  #tycmRoot .tycm-toggle.tycm-kind-5.set[data-idx="0"]{ background:#ffffff !important; }
  #tycmRoot .tycm-toggle.tycm-kind-5.set[data-idx="1"]{ background:#cfe8ff !important; }
  #tycmRoot .tycm-toggle.tycm-kind-5.set[data-idx="2"]{ background:#d9f7d9 !important; }
  #tycmRoot .tycm-toggle.tycm-kind-5.set[data-idx="3"]{ background:#ffd6d6 !important; }
  #tycmRoot .tycm-toggle.tycm-kind-5.set[data-idx="4"]{ background:#fff5c7 !important; }
  #tycmRoot .tycm-toggle.tycm-kind-5.set .k,
  #tycmRoot .tycm-toggle.tycm-kind-5.set .val{ color:var(--ty-dark) !important; }

  /* Length palette (Short / Normal / Long) */
  #tycmRoot .tycm-toggle.tycm-kind-length.set[data-idx="0"]{
    background:#0f1517 !important;
    border-color:#0f1517 !important;
  }
  #tycmRoot .tycm-toggle.tycm-kind-length.set[data-idx="0"] .k,
  #tycmRoot .tycm-toggle.tycm-kind-length.set[data-idx="0"] .val{ color:#ffffff !important; }

  #tycmRoot .tycm-toggle.tycm-kind-length.set[data-idx="1"]{ background:#fff5c7 !important; }
  #tycmRoot .tycm-toggle.tycm-kind-length.set[data-idx="1"] .k,
  #tycmRoot .tycm-toggle.tycm-kind-length.set[data-idx="1"] .val{ color:var(--ty-dark) !important; }

  #tycmRoot .tycm-toggle.tycm-kind-length.set[data-idx="2"]{
    background:#d85b5b !important;
    border-color:#d85b5b !important;
  }
  #tycmRoot .tycm-toggle.tycm-kind-length.set[data-idx="2"] .k,
  #tycmRoot .tycm-toggle.tycm-kind-length.set[data-idx="2"] .val{ color:#fff2a8 !important; }


  #tycmRoot .tycm-toggle-row{
    display:grid;
    grid-template-columns:1fr 1fr;
    gap:8px;
  }
  @media (max-width:420px){
    #tycmRoot.tycm-wrap{padding:0;}
    #tycmRoot .tycm-toggle-row{grid-template-columns:1fr; }
  }

  #tycmRoot .tycm-textarea{
    width:100%;
    border-radius:12px;
    border:1px solid var(--ty-border);
    background:#fff;
    color:#1b1f24;
    padding:10px 12px;
    font-size:14px;
    resize:vertical;
    min-height:76px;
    outline:none;
  }
  #tycmRoot .tycm-textarea:focus{
    border-color:rgba(239,94,20,.75);
    box-shadow:0 0 0 3px rgba(239,94,20,.22);
  }
  #tycmRoot .tycm-textarea::placeholder{color:rgba(107,118,128,.75);}
  #tycmRoot .tycm-textarea.tycm-report{
    min-height:190px;
    white-space:pre-wrap;
    font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,"Courier New",monospace;
    background:#fbfbfc;
  }

  #tycmRoot .tycm-actions{
    margin-top:12px;
    position:sticky;
    bottom:0;
    z-index:5;
    background:linear-gradient(to top, rgba(247,247,247,0.96), rgba(247,247,247,0.6));
    padding:10px 0 0;
  }
  #tycmRoot .tycm-actions-inner{
    display:flex;
    gap:10px;
    flex-wrap:wrap;
  }
  #tycmRoot .tycm-btn{
    appearance:none !important;
    -webkit-appearance:none !important;
    border-radius:999px !important;
    border:1px solid var(--ty-border) !important;
    padding:12px 14px !important;
    font-size:13px !important;
    font-weight:1000 !important;
    cursor:pointer !important;
    flex:1 1 150px;
    touch-action:manipulation;
    -webkit-tap-highlight-color:transparent;
    line-height:1.1 !important;
    background:#fff !important;
    color:var(--ty-dark) !important;
  }
  #tycmRoot .tycm-btn-primary{
    background:var(--slb-action-orange-bg,var(--ty-orange)) !important;
    border-color:var(--slb-action-orange-border,var(--ty-orange)) !important;
    color:#ffffff !important;
    box-shadow:var(--slb-action-orange-shadow,none) !important;
  }
  #tycmRoot .tycm-btn-secondary{
    background:#ffffff !important;
    color:var(--ty-dark) !important;
    border-color:rgba(15,21,23,.28) !important;
  }
  #tycmRoot .tycm-btn:active{transform:scale(0.99);}

  #tycmToast{
    position:fixed;
    left:50%;
    transform:translateX(-50%);
    bottom:18px;
    background:var(--ty-dark);
    color:#ffffff;
    border-radius:999px;
    padding:8px 12px;
    font-size:12px;
    border:1px solid rgba(239,94,20,0.8);
    opacity:0;
    pointer-events:none;
    transition:opacity .15s ease-out;
    z-index:9999;
    max-width:min(92vw, 520px);
    text-align:center;
  }
  #tycmToast.show{opacity:1;}
#tycmOutputCard{display:none !important;}
  #tycmRoot .tycm-checkRow{margin-top:8px;}
  #tycmRoot .tycm-check{display:flex;align-items:center;gap:8px;font-size:13px;color:var(--ty-dark);font-weight:800;}
  #tycmRoot .tycm-check input{width:18px;height:18px;}
`,
    html: `<div class="tycm-wrap" id="tycmRoot">
    <!-- ✅ Report Info -->
  <section class="tycm-card tycm-metaCard">
    <div class="tycm-card-title">Report Info</div>
    <div class="tycm-card-sub">Choose one, then enter names.</div>

    <div class="tycm-modeRow">
      <label class="tycm-radio">
        <input type="radio" name="tycmMode" value="self" checked>
        <span>For myself</span>
      </label>
      <label class="tycm-radio">
        <input type="radio" name="tycmMode" value="other">
        <span>For others</span>
      </label>
    </div>

    <div class="tycm-metaGrid" id="tycmSelfBox">
      <div>
        <div class="tycm-field-label">Your name</div>
        <input id="tycmSelfName" class="tycm-input" placeholder="Enter your name">
      </div>
    </div>

    <div class="tycm-metaGrid" id="tycmOtherBox" style="display:none;">
      <div>
        <div class="tycm-field-label">Doctor name</div>
        <input id="tycmDoctorName" class="tycm-input" placeholder="Enter doctor name">
      </div>
      <div>
        <div class="tycm-field-label">Patient name</div>
        <input id="tycmPatientName" class="tycm-input" placeholder="Enter patient name">
      </div>
    </div>

    <div class="tycm-metaFull">
      <div class="tycm-field-label">Short description of the problem</div>
      <input id="tycmProblem" class="tycm-input" placeholder="Example: Just checking up. / Headache and nausea.">
      <div class="tycm-checkRow">
        <label class="tycm-check"><input type="checkbox" id="tycmWellnessOnly"><span>Wellness Check Only</span></label>
      </div>
    </div>
  </section>

  <div class="tycm-hand-switch" aria-label="Switch hand panel">
    <button type="button" id="tycmGoLeft" class="active">Left Hand</button>
    <button type="button" id="tycmGoRight">Right Hand</button>
  </div>

  <div class="tycm-columns" id="tycmColumns">
    <!-- LEFT COLUMN -->
    <div class="tycm-col" id="tycmLeftCol">
      <section class="tycm-card">
        <div class="tycm-card-title">Pulse Length (Left)</div>
        <div class="tycm-card-sub">Overall length feel for left hand.</div>

        <div class="tycm-field-label">Length</div>
        <button type="button" class="tycm-toggle" data-field="left_length" data-options="short|normal|long" aria-pressed="false">
          <span class="k">Length</span>
          <span class="v"><span class="val">—</span></span>
        </button>
      </section>

      <section class="tycm-card">
        <div class="tycm-card-title">Left Hand</div>
        <div class="tycm-card-sub">Surface (external) and deep (internal) reads.</div>

        <div class="tycm-subgrid-title">Surface read</div>

        <div class="tycm-organ-name">Bladder</div>
        <div class="tycm-toggle-row">
          <button type="button" class="tycm-toggle" data-field="left_bladder_strength" data-options="missing|faint|normal|strong|damp" aria-pressed="false">
            <span class="k">Strength</span><span class="v"><span class="val">—</span></span>
          </button>
          <button type="button" class="tycm-toggle" data-field="left_bladder_speed" data-options="missing|slow|normal|fast|instable" aria-pressed="false">
            <span class="k">Speed</span><span class="v"><span class="val">—</span></span>
          </button>
        </div>

        <div class="tycm-organ-name">Gall Bladder</div>
        <div class="tycm-toggle-row">
          <button type="button" class="tycm-toggle" data-field="left_gb_strength" data-options="missing|faint|normal|strong|damp" aria-pressed="false">
            <span class="k">Strength</span><span class="v"><span class="val">—</span></span>
          </button>
          <button type="button" class="tycm-toggle" data-field="left_gb_speed" data-options="missing|slow|normal|fast|instable" aria-pressed="false">
            <span class="k">Speed</span><span class="v"><span class="val">—</span></span>
          </button>
        </div>

        <div class="tycm-organ-name">Small Intestine</div>
        <div class="tycm-toggle-row">
          <button type="button" class="tycm-toggle" data-field="left_si_strength" data-options="missing|faint|normal|strong|damp" aria-pressed="false">
            <span class="k">Strength</span><span class="v"><span class="val">—</span></span>
          </button>
          <button type="button" class="tycm-toggle" data-field="left_si_speed" data-options="missing|slow|normal|fast|instable" aria-pressed="false">
            <span class="k">Speed</span><span class="v"><span class="val">—</span></span>
          </button>
        </div>

        <div class="tycm-subgrid-title">Deep read</div>

        <div class="tycm-organ-name">Kidney Yang</div>
        <div class="tycm-toggle-row">
          <button type="button" class="tycm-toggle" data-field="left_kidney_yang_strength" data-options="missing|faint|normal|strong|damp" aria-pressed="false">
            <span class="k">Strength</span><span class="v"><span class="val">—</span></span>
          </button>
          <button type="button" class="tycm-toggle" data-field="left_kidney_yang_speed" data-options="missing|slow|normal|fast|instable" aria-pressed="false">
            <span class="k">Speed</span><span class="v"><span class="val">—</span></span>
          </button>
        </div>

        <div class="tycm-organ-name">Liver</div>
        <div class="tycm-toggle-row">
          <button type="button" class="tycm-toggle" data-field="left_liver_strength" data-options="missing|faint|normal|strong|damp" aria-pressed="false">
            <span class="k">Strength</span><span class="v"><span class="val">—</span></span>
          </button>
          <button type="button" class="tycm-toggle" data-field="left_liver_speed" data-options="missing|slow|normal|fast|instable" aria-pressed="false">
            <span class="k">Speed</span><span class="v"><span class="val">—</span></span>
          </button>
        </div>

        <div class="tycm-organ-name">Heart</div>
        <div class="tycm-toggle-row">
          <button type="button" class="tycm-toggle" data-field="left_heart_strength" data-options="missing|faint|normal|strong|damp" aria-pressed="false">
            <span class="k">Strength</span><span class="v"><span class="val">—</span></span>
          </button>
          <button type="button" class="tycm-toggle" data-field="left_heart_speed" data-options="missing|slow|normal|fast|instable" aria-pressed="false">
            <span class="k">Speed</span><span class="v"><span class="val">—</span></span>
          </button>
        </div>
      </section>
    </div>

    <!-- RIGHT COLUMN -->
    <div class="tycm-col" id="tycmRightCol">
      <section class="tycm-card">
        <div class="tycm-card-title">Pulse Length (Right)</div>
        <div class="tycm-card-sub">Overall length feel for right hand.</div>

        <div class="tycm-field-label">Length</div>
        <button type="button" class="tycm-toggle" data-field="right_length" data-options="short|normal|long" aria-pressed="false">
          <span class="k">Length</span>
          <span class="v"><span class="val">—</span></span>
        </button>
      </section>

      <section class="tycm-card">
        <div class="tycm-card-title">Right Hand</div>
        <div class="tycm-card-sub">Surface (external) and deep (internal) reads.</div>

        <div class="tycm-subgrid-title">Surface read</div>

        <div class="tycm-organ-name">Stomach</div>
        <div class="tycm-toggle-row">
          <button type="button" class="tycm-toggle" data-field="right_stomach_strength" data-options="missing|faint|normal|strong|damp" aria-pressed="false">
            <span class="k">Strength</span><span class="v"><span class="val">—</span></span>
          </button>
          <button type="button" class="tycm-toggle" data-field="right_stomach_speed" data-options="missing|slow|normal|fast|instable" aria-pressed="false">
            <span class="k">Speed</span><span class="v"><span class="val">—</span></span>
          </button>
        </div>

        <div class="tycm-organ-name">Big Intestine</div>
        <div class="tycm-toggle-row">
          <button type="button" class="tycm-toggle" data-field="right_li_strength" data-options="missing|faint|normal|strong|damp" aria-pressed="false">
            <span class="k">Strength</span><span class="v"><span class="val">—</span></span>
          </button>
          <button type="button" class="tycm-toggle" data-field="right_li_speed" data-options="missing|slow|normal|fast|instable" aria-pressed="false">
            <span class="k">Speed</span><span class="v"><span class="val">—</span></span>
          </button>
        </div>

        <div class="tycm-organ-name">Triple Burner</div>
        <div class="tycm-toggle-row">
          <button type="button" class="tycm-toggle" data-field="right_tb_strength" data-options="missing|faint|normal|strong|damp" aria-pressed="false">
            <span class="k">Strength</span><span class="v"><span class="val">—</span></span>
          </button>
          <button type="button" class="tycm-toggle" data-field="right_tb_speed" data-options="missing|slow|normal|fast|instable" aria-pressed="false">
            <span class="k">Speed</span><span class="v"><span class="val">—</span></span>
          </button>
        </div>

        <div class="tycm-subgrid-title">Deep read</div>

        <div class="tycm-organ-name">Spleen</div>
        <div class="tycm-toggle-row">
          <button type="button" class="tycm-toggle" data-field="right_spleen_strength" data-options="missing|faint|normal|strong|damp" aria-pressed="false">
            <span class="k">Strength</span><span class="v"><span class="val">—</span></span>
          </button>
          <button type="button" class="tycm-toggle" data-field="right_spleen_speed" data-options="missing|slow|normal|fast|instable" aria-pressed="false">
            <span class="k">Speed</span><span class="v"><span class="val">—</span></span>
          </button>
        </div>

        <div class="tycm-organ-name">Lung</div>
        <div class="tycm-toggle-row">
          <button type="button" class="tycm-toggle" data-field="right_lung_strength" data-options="missing|faint|normal|strong|damp" aria-pressed="false">
            <span class="k">Strength</span><span class="v"><span class="val">—</span></span>
          </button>
          <button type="button" class="tycm-toggle" data-field="right_lung_speed" data-options="missing|slow|normal|fast|instable" aria-pressed="false">
            <span class="k">Speed</span><span class="v"><span class="val">—</span></span>
          </button>
        </div>

        <div class="tycm-organ-name">Kidney Yin</div>
        <div class="tycm-toggle-row">
          <button type="button" class="tycm-toggle" data-field="right_kidney_yin_strength" data-options="missing|faint|normal|strong|damp" aria-pressed="false">
            <span class="k">Strength</span><span class="v"><span class="val">—</span></span>
          </button>
          <button type="button" class="tycm-toggle" data-field="right_kidney_yin_speed" data-options="missing|slow|normal|fast|instable" aria-pressed="false">
            <span class="k">Speed</span><span class="v"><span class="val">—</span></span>
          </button>
        </div>
      </section>
    </div>
  </div>

  <!-- Special Note + Output + Submit -->
  <section class="tycm-card" id="tycmOutputCard">
    <div class="tycm-card-title">Special Note</div>
    <div class="tycm-card-sub">Extra note for this case.</div>
    <textarea id="tycmSpecialNote" class="tycm-textarea" placeholder="Write anything important here..."></textarea>

    <div class="tycm-field-label" style="margin-top:10px;">Final report</div>
    <textarea id="tycmReportOutput" class="tycm-textarea tycm-report" placeholder="Press FINALIZE to generate report here."></textarea>

    <div class="tycm-actions">
      <div class="tycm-actions-inner">
        <button type="button" class="tycm-btn tycm-btn-secondary" id="tycmClearBtn">Clear</button>
        <button type="button" class="tycm-btn tycm-btn-primary" id="tycmFinalizeBtn">Finalize</button>
        <button type="button" class="tycm-btn tycm-btn-primary" id="tycmSubmitBtn">Save</button>
        <button type="button" class="tycm-btn" id="tycmEmailBtn">>>SI Juen</button>
      </div>
    </div>
  </section>
</div>

<div id="tycmToast">Ready.</div>`,
    js: `(function(){
  function boot(){
    var root = document.getElementById('tycmRoot');
    if(!root) return false;
    try{ if(root.dataset && root.dataset.tycmBooted === '1') return true; if(root.dataset) root.dataset.tycmBooted = '1'; }catch(e){}

    function showToast(msg){
      var t = document.getElementById('tycmToast');
      if(!t) return;
      t.textContent = msg || 'Ready.';
      t.classList.add('show');
      clearTimeout(showToast._timer);
      showToast._timer = setTimeout(function(){
 t.classList.remove('show'); }, 1800);
    }

    function cap(word){
      if(!word) return 'N/A';
      return word.charAt(0).toUpperCase() + word.slice(1);
    }

    // ===== Mode switch (self / other) =====
    var selfBox = document.getElementById('tycmSelfBox');
    var otherBox = document.getElementById('tycmOtherBox');
    var selfNameEl = document.getElementById('tycmSelfName');
    var docEl = document.getElementById('tycmDoctorName');
    var patEl = document.getElementById('tycmPatientName');
    var probEl = document.getElementById('tycmProblem');
    var wellnessEl = document.getElementById('tycmWellnessOnly');

    function getMode(){
      var r = root.querySelector('input[name="tycmMode"]:checked');
      return (r && r.value) ? r.value : 'self';
    }
    function syncMode(){
      var mode = getMode();

      // update active style on the two mode pills
      Array.prototype.slice.call(root.querySelectorAll('.tycm-radio')).forEach(function(lbl){
        try{
          var inp = lbl.querySelector('input');
          if(inp && inp.value === mode){ lbl.classList.add('active'); }
          else{ lbl.classList.remove('active'); }
        }catch(e){}
      });

      if(selfBox) selfBox.style.display = (mode === 'self') ? 'grid' : 'none';
      if(otherBox) otherBox.style.display = (mode === 'other') ? 'grid' : 'none';
      if(mode === 'other' && patEl){
        setTimeout(function(){
 try{ patEl.focus(); }catch(e){} }, 0);
      }
    }
    Array.prototype.slice.call(root.querySelectorAll('input[name="tycmMode"]')).forEach(function(r){
      r.addEventListener('change', syncMode);
    });
    syncMode();

    // ===== Wellness Check Only lock =====
    (function(){
      if(!wellnessEl || !probEl) return;
      function setPrev(val){
        try{ probEl.dataset.prevVal = String(val||''); }catch(_e){}
      }
      function getPrev(){
        try{ return String(probEl.dataset.prevVal||''); }catch(_e){ return ''; }
      }
      function clearPrev(){
        try{ delete probEl.dataset.prevVal; }catch(_e){}
      }

      function syncWellnessLock(){
        var on = !!wellnessEl.checked;
        if(on){
          setPrev(probEl.value || '');
          var cur = String(probEl.value||'').trim();
          if(!cur) probEl.value = 'Wellness Check Only';
          probEl.disabled = true;
        }else{
          var prev = getPrev();
          var cur2 = String(probEl.value||'').trim();
          probEl.disabled = false;
          if(cur2 === 'Wellness Check Only' && prev) probEl.value = prev;
          clearPrev();
        }
      }

      wellnessEl.addEventListener('change', syncWellnessLock);
      probEl.addEventListener('input', function(){
        if(!wellnessEl.checked){
          setPrev(probEl.value || '');
        }
      });

      syncWellnessLock();
    })();

    // ===== Toggle system =====
    // Canonical option order (prevents accidental scrambling)
    var TYCM_STRENGTH_OPTS = ['missing','faint','normal','strong','damp'];
    var TYCM_SPEED_OPTS    = ['missing','slow','normal','fast','instable'];

    function toggleKind(btn){
      var k = btn ? btn.querySelector('.k') : null;
      var label = k ? (k.textContent || '').trim().toLowerCase() : '';
      if(label === 'strength') return 'strength';
      if(label === 'speed') return 'speed';
      return '';
    }

    function getToggleOpts(btn){
      var raw = (btn.dataset.options || '').split('|').map(function(s){ return (s||'').trim(); }).filter(Boolean);
      var kind = toggleKind(btn);
      if(kind === 'strength') return TYCM_STRENGTH_OPTS.slice();
      if(kind === 'speed') return TYCM_SPEED_OPTS.slice();
      return raw;
    }

    function formatToggleVal(btn, val){
      var kind = toggleKind(btn);
      if(kind === 'strength'){
        var m = {missing:'1.Missing', faint:'2.Faint', normal:'3.Normal', strong:'4.Strong', damp:'5.Damp'};
        return m[val] || cap(val);
      }
      if(kind === 'speed'){
        var m2 = {missing:'1.Missing', slow:'2.Slow', normal:'3.Normal', fast:'4.Fast', instable:'5.Instable'};
        return m2[val] || cap(val);
      }
      return cap(val);
    }

    function setToggle(btn, idx){
      var opts = getToggleOpts(btn);
      btn.dataset.idx = String(idx);

      var valEl = btn.querySelector('.val');
      if(idx < 0 || idx >= opts.length){
        delete btn.dataset.value;
        btn.classList.remove('set');
        btn.setAttribute('aria-pressed','false');
        if(valEl) valEl.textContent = '—';
        return;
      }

      var val = opts[idx];
      btn.dataset.value = val;
      btn.classList.add('set');
      btn.setAttribute('aria-pressed','true');
      if(valEl) valEl.textContent = formatToggleVal(btn, val);
    }

    function cycle(btn){
      var opts = getToggleOpts(btn);
      if(!opts.length) return;

      var cur = parseInt(btn.dataset.idx || '-1', 10);
      if(isNaN(cur)) cur = -1;

      var next = cur + 1;
      if(next >= opts.length) next = 0;

      setToggle(btn, next);
    }

    // Bind directly (more reliable in Shopify sandbox)
    var toggles = Array.prototype.slice.call(root.querySelectorAll('.tycm-toggle'));
    toggles.forEach(function(btn){
      try{
        var rawOpt = String(btn.dataset.options||'');
        if(rawOpt.indexOf('short|normal|long') >= 0){
          btn.classList.add('tycm-kind-length');
        } else {
          var knd = toggleKind(btn);
          if(knd === 'strength' || knd === 'speed') btn.classList.add('tycm-kind-5');
        }
      }catch(_e){}
      btn.addEventListener('click', function(e){
        e.preventDefault();
        cycle(btn);
      });
      btn.addEventListener('keydown', function(e){
        if(e.key === 'Enter' || e.key === ' '){
          e.preventDefault();
          cycle(btn);
        }
      });
      setToggle(btn, -1);
    });

    function getValue(field){
      var btn = root.querySelector('.tycm-toggle[data-field="'+field+'"]');
      var v = btn ? (btn.dataset.value || '') : '';
      // Report output wants simple tokens (no "Speed:" / "Strength:" words)
      return v ? (v.toLowerCase()) : 'N/A';
    }

    function organLine(label, strengthField, speedField){
      // Example: Heart: faint-fast
      return label + ': ' + getValue(strengthField) + '-' + getValue(speedField);
    }

    function metaLine(){
      var mode = getMode();
      var selfName = (selfNameEl && selfNameEl.value ? selfNameEl.value : '').trim();
      var doctorName = (docEl && docEl.value ? docEl.value : '').trim();
      var patientName = (patEl && patEl.value ? patEl.value : '').trim();
      var problem = (probEl && probEl.value ? probEl.value : '').trim();

      var wellness = !!(wellnessEl && wellnessEl.checked);
      if(!problem && wellness) problem = 'Wellness Check Only';

      var reportedBy = (mode === 'self') ? selfName : doctorName;
      var pulseFor = (mode === 'self') ? selfName : patientName;

      return {
        pulseFor: pulseFor || '—',
        reportedBy: reportedBy || '—',
        problem: problem || '—'
      };
    }

    function buildReport(){
      var lines = [];
      var m = metaLine();

      lines.push('Pulse Read For: ' + m.pulseFor);
      lines.push('Reported By: ' + m.reportedBy);
      lines.push('Problem: ' + m.problem);
      lines.push('');

      lines.push('Pulse length:');
      lines.push('Left hand: ' + getValue('left_length'));
      lines.push('Right hand: ' + getValue('right_length'));
      lines.push('');

      lines.push('Left hand:');
      lines.push('Surface read:');
      lines.push(organLine('Bladder', 'left_bladder_strength', 'left_bladder_speed'));
      lines.push(organLine('Gall Bladder', 'left_gb_strength', 'left_gb_speed'));
      lines.push(organLine('Small Intestine', 'left_si_strength', 'left_si_speed'));
      lines.push('');
      lines.push('Deep read:');
      lines.push(organLine('Kidney(Yang)', 'left_kidney_yang_strength', 'left_kidney_yang_speed'));
      lines.push(organLine('Liver', 'left_liver_strength', 'left_liver_speed'));
      lines.push(organLine('Heart', 'left_heart_strength', 'left_heart_speed'));
      lines.push('');

      lines.push('Right hand:');
      lines.push('Surface read:');
      lines.push(organLine('Stomach', 'right_stomach_strength', 'right_stomach_speed'));
      lines.push(organLine('Big Intestine', 'right_li_strength', 'right_li_speed'));
      lines.push(organLine('Triple Burner', 'right_tb_strength', 'right_tb_speed'));
      lines.push('');
      lines.push('Deep read:');
      lines.push(organLine('Spleen', 'right_spleen_strength', 'right_spleen_speed'));
      lines.push(organLine('Lung', 'right_lung_strength', 'right_lung_speed'));
      lines.push(organLine('Kidney(Yin)', 'right_kidney_yin_strength', 'right_kidney_yin_speed'));
      lines.push('');

      lines.push('Special note:');
      var note = (document.getElementById('tycmSpecialNote').value || '').trim();
      lines.push(note ? note : 'None.');

      return lines.join('\n');
    }

    function fallbackCopy(text){
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly','');
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      ta.style.top = '0';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch(e){ ok = false; }
      document.body.removeChild(ta);
      return ok;
    }

    function copyText(text){
      try{
        if(navigator.clipboard && navigator.clipboard.writeText){
          return navigator.clipboard.writeText(text).then(function(){
 return true; }).catch(function(){
 return fallbackCopy(text); });
        }
      }catch(e){}
      return Promise.resolve(fallbackCopy(text));
    }

    function finalize(){
      var report = buildReport();
      var out = document.getElementById('tycmReportOutput');
      out.value = report;

      return copyText(report).then(function(ok){
        showToast(ok ? 'Report finalized + copied.' : 'Report finalized. (Select + copy)');
        return report;
      });
    }

    function copyOnly(){
      var out = document.getElementById('tycmReportOutput');
      var text = (out.value || '').trim();
      if(!text){
        showToast('No report yet. Press FINALIZE first.');
        return;
      }
      copyText(text).then(function(ok){
        showToast(ok ? 'Copied.' : 'Copy failed. Select + copy.');
      });
    }

    document.getElementById('tycmFinalizeBtn').addEventListener('click', function(){ finalize(); });
    var copyBtn = document.getElementById('tycmCopyBtn');
    if(copyBtn){ copyBtn.addEventListener('click', copyOnly); }

    document.getElementById('tycmClearBtn').addEventListener('click', function(){
      toggles.forEach(function(btn){ setToggle(btn, -1); });
      if(selfNameEl) selfNameEl.value = '';
      if(docEl) docEl.value = '';
      if(patEl) patEl.value = '';
      if(probEl) probEl.value = '';
      if(probEl){
        try{ probEl.disabled = false; delete probEl.dataset.prevVal; }catch(_e){}
      }
      if(wellnessEl) wellnessEl.checked = false;
      // ensure wellness lock state resets
      try{ if(typeof wellnessEl !== 'undefined' && wellnessEl && probEl){ /* syncWellnessLock is in closure */ } }catch(_e){}
      var selfRadio = root.querySelector('input[name="tycmMode"][value="self"]');
      if(selfRadio){ selfRadio.checked = true; syncMode(); }
      document.getElementById('tycmSpecialNote').value = '';
      document.getElementById('tycmReportOutput').value = '';
      showToast('Cleared.');
    });

    function collectEmailPayload(report){
      var m = metaLine();
      var mode = getMode();
      var selfName = (selfNameEl && selfNameEl.value ? selfNameEl.value : '').trim();
      var doctorName = (docEl && docEl.value ? docEl.value : '').trim();
      var patientName = (patEl && patEl.value ? patEl.value : '').trim();
      var problem = (probEl && probEl.value ? probEl.value : '').trim();
      var note = (document.getElementById('tycmSpecialNote').value || '').trim();
      return { report: report, meta: m, mode: mode, selfName: selfName, doctorName: doctorName, patientName: patientName, problem: problem, specialNote: note };
    }

    // Expose API for SLB wrapper UI
    try{
      window.TYCM_API = window.TYCM_API || {};
      window.TYCM_API.buildReport = function(noteOverride){
        var ne = document.getElementById('tycmSpecialNote');
        if(ne && typeof noteOverride === 'string') ne.value = noteOverride;
        return buildReport();
      };
      window.TYCM_API.getEmailPayload = function(noteOverride){
        var ne = document.getElementById('tycmSpecialNote');
        if(ne && typeof noteOverride === 'string') ne.value = noteOverride;
        var rep = buildReport();
        return collectEmailPayload(rep);
      };
      window.TYCM_API.clearAll = function(){
        toggles.forEach(function(btn){ setToggle(btn, -1); });
        if(selfNameEl) selfNameEl.value = '';
        if(docEl) docEl.value = '';
        if(patEl) patEl.value = '';
        if(probEl) probEl.value = '';
        if(probEl){
          try{ probEl.disabled = false; delete probEl.dataset.prevVal; }catch(_e){}
        }
        if(wellnessEl) wellnessEl.checked = false;
        var selfRadio = root.querySelector('input[name="tycmMode"][value="self"]');
        if(selfRadio){ selfRadio.checked = true; syncMode(); }
        var ne = document.getElementById('tycmSpecialNote');
        if(ne) ne.value = '';
        var oe = document.getElementById('tycmReportOutput');
        if(oe) oe.value = '';
        showToast('Cleared.');
      };
    }catch(_e){}

    var submitBtn = document.getElementById('tycmSubmitBtn');
    if(submitBtn){
      submitBtn.addEventListener('click', function(){
        finalize().then(function(report){
          if(!window.SLB_CMR || typeof window.SLB_CMR.submitReport !== 'function'){
            showToast('Please login first.');
            return;
          }
          submitBtn.disabled = true;
          showToast('Submitting...');
          Promise.resolve(window.SLB_CMR.submitReport(report)).then(function(){
            showToast('Saved.');
          }).catch(function(){
            showToast('Submit failed.');
          }).finally(function(){ submitBtn.disabled = false; });
        });
      });
    }

    var emailBtn = document.getElementById('tycmEmailBtn');
    if(emailBtn){
      emailBtn.addEventListener('click', function(){
        finalize().then(function(report){
          if(window.SLB_CMR && typeof window.SLB_CMR.emailJee === 'function'){
            var payload = collectEmailPayload(report);
            emailBtn.disabled = true;
            showToast('Emailing...');
            Promise.resolve(window.SLB_CMR.emailJee(payload)).then(function(){
              showToast('Email sent.');
            }).catch(function(){
              showToast('Email failed.');
            }).finally(function(){ emailBtn.disabled = false; });
            return;
          }
          // Fallback: open mail client (best effort)
          var subject = 'CM Pulse Report - ' + new Date().toLocaleString();
          var body = report;
          var maxBody = 1800;
          if(body.length > maxBody){
            body = report.slice(0, maxBody) + '\n\n(Report was long. Full report is copied already. Paste it into your email.)';
          }
          var mailto = 'mailto:tinjee@chiinnature.com'
            + '?subject=' + encodeURIComponent(subject)
            + '&body=' + encodeURIComponent(body);
          window.location.href = mailto;
          showToast('Opening email...');
        });
      });
    }

// Mobile hand switch (scroll to panel)
    var cols = document.getElementById('tycmColumns');
    var leftCol = document.getElementById('tycmLeftCol');
    var rightCol = document.getElementById('tycmRightCol');
    var goL = document.getElementById('tycmGoLeft');
    var goR = document.getElementById('tycmGoRight');

    function setActiveHand(which){
      if(which === 'right'){
        goR.classList.add('active'); goL.classList.remove('active');
      }else{
        goL.classList.add('active'); goR.classList.remove('active');
      }
    }

    goL.addEventListener('click', function(){
      if(cols && leftCol && cols.scrollTo){
        cols.scrollTo({left: leftCol.offsetLeft - cols.offsetLeft, behavior:'smooth'});
      }
      setActiveHand('left');
    });
    goR.addEventListener('click', function(){
      if(cols && rightCol && cols.scrollTo){
        cols.scrollTo({left: rightCol.offsetLeft - cols.offsetLeft, behavior:'smooth'});
      }
      setActiveHand('right');
    });

    if(cols){
      var ticking = false;
      cols.addEventListener('scroll', function(){
        if(ticking) return;
        ticking = true;
        requestAnimationFrame(function(){

          ticking = false;
          if(window.matchMedia && window.matchMedia('(max-width: 860px)').matches){
            var mid = cols.scrollLeft + cols.clientWidth/2;
            var rightMid = rightCol.offsetLeft + rightCol.clientWidth/2 - cols.offsetLeft;
            setActiveHand(mid >= rightMid ? 'right' : 'left');
          }
        });
      }, {passive:true});
    }

    showToast('Ready.');
    return true;
  }

  function tryBoot(){
    return boot();
  }

  try{ window.__SLB_CMR_PULSE_TRYBOOT__ = tryBoot; }catch(e){}

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', tryBoot);
  }else{
    tryBoot();
  }
})();`
  };

  /* SLB_CMR_PULSE_RUNTIME */
  (function(){
  function boot(){
    var root = document.getElementById('tycmRoot');
    if(!root) return false;
    try{ if(root.dataset && root.dataset.tycmBooted === '1') return true; if(root.dataset) root.dataset.tycmBooted = '1'; }catch(e){}

    function showToast(msg){
      var t = document.getElementById('tycmToast');
      if(!t) return;
      t.textContent = msg || 'Ready.';
      t.classList.add('show');
      clearTimeout(showToast._timer);
      showToast._timer = setTimeout(function(){
 t.classList.remove('show'); }, 1800);
    }

    function cap(word){
      if(!word) return 'N/A';
      return word.charAt(0).toUpperCase() + word.slice(1);
    }

    // ===== Mode switch (self / other) =====
    var selfBox = document.getElementById('tycmSelfBox');
    var otherBox = document.getElementById('tycmOtherBox');
    var selfNameEl = document.getElementById('tycmSelfName');
    var docEl = document.getElementById('tycmDoctorName');
    var patEl = document.getElementById('tycmPatientName');
    var probEl = document.getElementById('tycmProblem');
    var wellnessEl = document.getElementById('tycmWellnessOnly');

    function getMode(){
      var r = root.querySelector('input[name="tycmMode"]:checked');
      return (r && r.value) ? r.value : 'self';
    }
    function syncMode(){
      var mode = getMode();

      // update active style on the two mode pills
      Array.prototype.slice.call(root.querySelectorAll('.tycm-radio')).forEach(function(lbl){
        try{
          var inp = lbl.querySelector('input');
          if(inp && inp.value === mode){ lbl.classList.add('active'); }
          else{ lbl.classList.remove('active'); }
        }catch(e){}
      });

      if(selfBox) selfBox.style.display = (mode === 'self') ? 'grid' : 'none';
      if(otherBox) otherBox.style.display = (mode === 'other') ? 'grid' : 'none';
      if(mode === 'other' && patEl){
        setTimeout(function(){
 try{ patEl.focus(); }catch(e){} }, 0);
      }
    }
    Array.prototype.slice.call(root.querySelectorAll('input[name="tycmMode"]')).forEach(function(r){
      r.addEventListener('change', syncMode);
    });
    syncMode();

    // ===== Wellness Check Only lock =====
    (function(){
      if(!wellnessEl || !probEl) return;
      function setPrev(val){
        try{ probEl.dataset.prevVal = String(val||''); }catch(_e){}
      }
      function getPrev(){
        try{ return String(probEl.dataset.prevVal||''); }catch(_e){ return ''; }
      }
      function clearPrev(){
        try{ delete probEl.dataset.prevVal; }catch(_e){}
      }

      function syncWellnessLock(){
        var on = !!wellnessEl.checked;
        if(on){
          setPrev(probEl.value || '');
          var cur = String(probEl.value||'').trim();
          if(!cur) probEl.value = 'Wellness Check Only';
          probEl.disabled = true;
        }else{
          var prev = getPrev();
          var cur2 = String(probEl.value||'').trim();
          probEl.disabled = false;
          if(cur2 === 'Wellness Check Only' && prev) probEl.value = prev;
          clearPrev();
        }
      }

      wellnessEl.addEventListener('change', syncWellnessLock);
      probEl.addEventListener('input', function(){
        if(!wellnessEl.checked){
          setPrev(probEl.value || '');
        }
      });

      syncWellnessLock();
    })();

    // ===== Toggle system =====
    // Canonical option order (prevents accidental scrambling)
    var TYCM_STRENGTH_OPTS = ['missing','faint','normal','strong','damp'];
    var TYCM_SPEED_OPTS    = ['missing','slow','normal','fast','instable'];

    function toggleKind(btn){
      var k = btn ? btn.querySelector('.k') : null;
      var label = k ? (k.textContent || '').trim().toLowerCase() : '';
      if(label === 'strength') return 'strength';
      if(label === 'speed') return 'speed';
      return '';
    }

    function getToggleOpts(btn){
      var raw = (btn.dataset.options || '').split('|').map(function(s){ return (s||'').trim(); }).filter(Boolean);
      var kind = toggleKind(btn);
      if(kind === 'strength') return TYCM_STRENGTH_OPTS.slice();
      if(kind === 'speed') return TYCM_SPEED_OPTS.slice();
      return raw;
    }

    function formatToggleVal(btn, val){
      var kind = toggleKind(btn);
      if(kind === 'strength'){
        var m = {missing:'1.Missing', faint:'2.Faint', normal:'3.Normal', strong:'4.Strong', damp:'5.Damp'};
        return m[val] || cap(val);
      }
      if(kind === 'speed'){
        var m2 = {missing:'1.Missing', slow:'2.Slow', normal:'3.Normal', fast:'4.Fast', instable:'5.Instable'};
        return m2[val] || cap(val);
      }
      return cap(val);
    }

    function setToggle(btn, idx){
      var opts = getToggleOpts(btn);
      btn.dataset.idx = String(idx);

      var valEl = btn.querySelector('.val');
      if(idx < 0 || idx >= opts.length){
        delete btn.dataset.value;
        btn.classList.remove('set');
        btn.setAttribute('aria-pressed','false');
        if(valEl) valEl.textContent = '—';
        return;
      }

      var val = opts[idx];
      btn.dataset.value = val;
      btn.classList.add('set');
      btn.setAttribute('aria-pressed','true');
      if(valEl) valEl.textContent = formatToggleVal(btn, val);
    }

    function cycle(btn){
      var opts = getToggleOpts(btn);
      if(!opts.length) return;

      var cur = parseInt(btn.dataset.idx || '-1', 10);
      if(isNaN(cur)) cur = -1;

      var next = cur + 1;
      if(next >= opts.length) next = 0;

      setToggle(btn, next);
    }

    // Bind directly (more reliable in Shopify sandbox)
    var toggles = Array.prototype.slice.call(root.querySelectorAll('.tycm-toggle'));
    toggles.forEach(function(btn){
      try{
        var rawOpt = String(btn.dataset.options||'');
        if(rawOpt.indexOf('short|normal|long') >= 0){
          btn.classList.add('tycm-kind-length');
        } else {
          var knd = toggleKind(btn);
          if(knd === 'strength' || knd === 'speed') btn.classList.add('tycm-kind-5');
        }
      }catch(_e){}
      btn.addEventListener('click', function(e){
        e.preventDefault();
        cycle(btn);
      });
      btn.addEventListener('keydown', function(e){
        if(e.key === 'Enter' || e.key === ' '){
          e.preventDefault();
          cycle(btn);
        }
      });
      setToggle(btn, -1);
    });

    function getValue(field){
      var btn = root.querySelector('.tycm-toggle[data-field="'+field+'"]');
      var v = btn ? (btn.dataset.value || '') : '';
      // Report output wants simple tokens (no "Speed:" / "Strength:" words)
      return v ? (v.toLowerCase()) : 'N/A';
    }

    function organLine(label, strengthField, speedField){
      // Example: Heart: faint-fast
      return label + ': ' + getValue(strengthField) + '-' + getValue(speedField);
    }

    function metaLine(){
      var mode = getMode();
      var selfName = (selfNameEl && selfNameEl.value ? selfNameEl.value : '').trim();
      var doctorName = (docEl && docEl.value ? docEl.value : '').trim();
      var patientName = (patEl && patEl.value ? patEl.value : '').trim();
      var problem = (probEl && probEl.value ? probEl.value : '').trim();

      var wellness = !!(wellnessEl && wellnessEl.checked);
      if(!problem && wellness) problem = 'Wellness Check Only';

      var reportedBy = (mode === 'self') ? selfName : doctorName;
      var pulseFor = (mode === 'self') ? selfName : patientName;

      return {
        pulseFor: pulseFor || '—',
        reportedBy: reportedBy || '—',
        problem: problem || '—'
      };
    }

    function buildReport(){
      var lines = [];
      var m = metaLine();

      lines.push('Pulse Read For: ' + m.pulseFor);
      lines.push('Reported By: ' + m.reportedBy);
      lines.push('Problem: ' + m.problem);
      lines.push('');

      lines.push('Pulse length:');
      lines.push('Left hand: ' + getValue('left_length'));
      lines.push('Right hand: ' + getValue('right_length'));
      lines.push('');

      lines.push('Left hand:');
      lines.push('Surface read:');
      lines.push(organLine('Bladder', 'left_bladder_strength', 'left_bladder_speed'));
      lines.push(organLine('Gall Bladder', 'left_gb_strength', 'left_gb_speed'));
      lines.push(organLine('Small Intestine', 'left_si_strength', 'left_si_speed'));
      lines.push('');
      lines.push('Deep read:');
      lines.push(organLine('Kidney(Yang)', 'left_kidney_yang_strength', 'left_kidney_yang_speed'));
      lines.push(organLine('Liver', 'left_liver_strength', 'left_liver_speed'));
      lines.push(organLine('Heart', 'left_heart_strength', 'left_heart_speed'));
      lines.push('');

      lines.push('Right hand:');
      lines.push('Surface read:');
      lines.push(organLine('Stomach', 'right_stomach_strength', 'right_stomach_speed'));
      lines.push(organLine('Big Intestine', 'right_li_strength', 'right_li_speed'));
      lines.push(organLine('Triple Burner', 'right_tb_strength', 'right_tb_speed'));
      lines.push('');
      lines.push('Deep read:');
      lines.push(organLine('Spleen', 'right_spleen_strength', 'right_spleen_speed'));
      lines.push(organLine('Lung', 'right_lung_strength', 'right_lung_speed'));
      lines.push(organLine('Kidney(Yin)', 'right_kidney_yin_strength', 'right_kidney_yin_speed'));
      lines.push('');

      lines.push('Special note:');
      var note = (document.getElementById('tycmSpecialNote').value || '').trim();
      lines.push(note ? note : 'None.');

      return lines.join('\n');
    }

    function fallbackCopy(text){
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly','');
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      ta.style.top = '0';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch(e){ ok = false; }
      document.body.removeChild(ta);
      return ok;
    }

    function copyText(text){
      try{
        if(navigator.clipboard && navigator.clipboard.writeText){
          return navigator.clipboard.writeText(text).then(function(){
 return true; }).catch(function(){
 return fallbackCopy(text); });
        }
      }catch(e){}
      return Promise.resolve(fallbackCopy(text));
    }

    function finalize(){
      var report = buildReport();
      var out = document.getElementById('tycmReportOutput');
      out.value = report;

      return copyText(report).then(function(ok){
        showToast(ok ? 'Report finalized + copied.' : 'Report finalized. (Select + copy)');
        return report;
      });
    }

    function copyOnly(){
      var out = document.getElementById('tycmReportOutput');
      var text = (out.value || '').trim();
      if(!text){
        showToast('No report yet. Press FINALIZE first.');
        return;
      }
      copyText(text).then(function(ok){
        showToast(ok ? 'Copied.' : 'Copy failed. Select + copy.');
      });
    }

    document.getElementById('tycmFinalizeBtn').addEventListener('click', function(){ finalize(); });
    var copyBtn = document.getElementById('tycmCopyBtn');
    if(copyBtn){ copyBtn.addEventListener('click', copyOnly); }

    document.getElementById('tycmClearBtn').addEventListener('click', function(){
      toggles.forEach(function(btn){ setToggle(btn, -1); });
      if(selfNameEl) selfNameEl.value = '';
      if(docEl) docEl.value = '';
      if(patEl) patEl.value = '';
      if(probEl) probEl.value = '';
      if(probEl){
        try{ probEl.disabled = false; delete probEl.dataset.prevVal; }catch(_e){}
      }
      if(wellnessEl) wellnessEl.checked = false;
      // ensure wellness lock state resets
      try{ if(typeof wellnessEl !== 'undefined' && wellnessEl && probEl){ /* syncWellnessLock is in closure */ } }catch(_e){}
      var selfRadio = root.querySelector('input[name="tycmMode"][value="self"]');
      if(selfRadio){ selfRadio.checked = true; syncMode(); }
      document.getElementById('tycmSpecialNote').value = '';
      document.getElementById('tycmReportOutput').value = '';
      showToast('Cleared.');
    });

    function collectEmailPayload(report){
      var m = metaLine();
      var mode = getMode();
      var selfName = (selfNameEl && selfNameEl.value ? selfNameEl.value : '').trim();
      var doctorName = (docEl && docEl.value ? docEl.value : '').trim();
      var patientName = (patEl && patEl.value ? patEl.value : '').trim();
      var problem = (probEl && probEl.value ? probEl.value : '').trim();
      var note = (document.getElementById('tycmSpecialNote').value || '').trim();
      return { report: report, meta: m, mode: mode, selfName: selfName, doctorName: doctorName, patientName: patientName, problem: problem, specialNote: note };
    }

    // Expose API for SLB wrapper UI
    try{
      window.TYCM_API = window.TYCM_API || {};
      window.TYCM_API.buildReport = function(noteOverride){
        var ne = document.getElementById('tycmSpecialNote');
        if(ne && typeof noteOverride === 'string') ne.value = noteOverride;
        return buildReport();
      };
      window.TYCM_API.getEmailPayload = function(noteOverride){
        var ne = document.getElementById('tycmSpecialNote');
        if(ne && typeof noteOverride === 'string') ne.value = noteOverride;
        var rep = buildReport();
        return collectEmailPayload(rep);
      };
      window.TYCM_API.clearAll = function(){
        toggles.forEach(function(btn){ setToggle(btn, -1); });
        if(selfNameEl) selfNameEl.value = '';
        if(docEl) docEl.value = '';
        if(patEl) patEl.value = '';
        if(probEl) probEl.value = '';
        if(probEl){
          try{ probEl.disabled = false; delete probEl.dataset.prevVal; }catch(_e){}
        }
        if(wellnessEl) wellnessEl.checked = false;
        var selfRadio = root.querySelector('input[name="tycmMode"][value="self"]');
        if(selfRadio){ selfRadio.checked = true; syncMode(); }
        var ne = document.getElementById('tycmSpecialNote');
        if(ne) ne.value = '';
        var oe = document.getElementById('tycmReportOutput');
        if(oe) oe.value = '';
        showToast('Cleared.');
      };
    }catch(_e){}

    var submitBtn = document.getElementById('tycmSubmitBtn');
    if(submitBtn){
      submitBtn.addEventListener('click', function(){
        finalize().then(function(report){
          if(!window.SLB_CMR || typeof window.SLB_CMR.submitReport !== 'function'){
            showToast('Please login first.');
            return;
          }
          submitBtn.disabled = true;
          showToast('Submitting...');
          Promise.resolve(window.SLB_CMR.submitReport(report)).then(function(){
            showToast('Saved.');
          }).catch(function(){
            showToast('Submit failed.');
          }).finally(function(){ submitBtn.disabled = false; });
        });
      });
    }

    var emailBtn = document.getElementById('tycmEmailBtn');
    if(emailBtn){
      emailBtn.addEventListener('click', function(){
        finalize().then(function(report){
          if(window.SLB_CMR && typeof window.SLB_CMR.emailJee === 'function'){
            var payload = collectEmailPayload(report);
            emailBtn.disabled = true;
            showToast('Emailing...');
            Promise.resolve(window.SLB_CMR.emailJee(payload)).then(function(){
              showToast('Email sent.');
            }).catch(function(){
              showToast('Email failed.');
            }).finally(function(){ emailBtn.disabled = false; });
            return;
          }
          // Fallback: open mail client (best effort)
          var subject = 'CM Pulse Report - ' + new Date().toLocaleString();
          var body = report;
          var maxBody = 1800;
          if(body.length > maxBody){
            body = report.slice(0, maxBody) + '\n\n(Report was long. Full report is copied already. Paste it into your email.)';
          }
          var mailto = 'mailto:tinjee@chiinnature.com'
            + '?subject=' + encodeURIComponent(subject)
            + '&body=' + encodeURIComponent(body);
          window.location.href = mailto;
          showToast('Opening email...');
        });
      });
    }

// Mobile hand switch (scroll to panel)
    var cols = document.getElementById('tycmColumns');
    var leftCol = document.getElementById('tycmLeftCol');
    var rightCol = document.getElementById('tycmRightCol');
    var goL = document.getElementById('tycmGoLeft');
    var goR = document.getElementById('tycmGoRight');

    function setActiveHand(which){
      if(which === 'right'){
        goR.classList.add('active'); goL.classList.remove('active');
      }else{
        goL.classList.add('active'); goR.classList.remove('active');
      }
    }

    goL.addEventListener('click', function(){
      if(cols && leftCol && cols.scrollTo){
        cols.scrollTo({left: leftCol.offsetLeft - cols.offsetLeft, behavior:'smooth'});
      }
      setActiveHand('left');
    });
    goR.addEventListener('click', function(){
      if(cols && rightCol && cols.scrollTo){
        cols.scrollTo({left: rightCol.offsetLeft - cols.offsetLeft, behavior:'smooth'});
      }
      setActiveHand('right');
    });

    if(cols){
      var ticking = false;
      cols.addEventListener('scroll', function(){
        if(ticking) return;
        ticking = true;
        requestAnimationFrame(function(){

          ticking = false;
          if(window.matchMedia && window.matchMedia('(max-width: 860px)').matches){
            var mid = cols.scrollLeft + cols.clientWidth/2;
            var rightMid = rightCol.offsetLeft + rightCol.clientWidth/2 - cols.offsetLeft;
            setActiveHand(mid >= rightMid ? 'right' : 'left');
          }
        });
      }, {passive:true});
    }

    showToast('Ready.');
    return true;
  }

  function tryBoot(){
    return boot();
  }

  try{ window.__SLB_CMR_PULSE_TRYBOOT__ = tryBoot; }catch(e){}

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', tryBoot);
  }else{
    tryBoot();
  }
})();

  function mountPulseTool(mountEl){
    if(!mountEl) return;
    // Style (scoped to #tycmRoot mostly)
    injectStyleOnce('slbCmrPulseCss', PULSE.css);
    // Inject HTML (no script tags)
    mountEl.innerHTML = PULSE.html;

    // Provide bridge
    window.SLB_CMR = window.SLB_CMR || {};
    window.SLB_CMR.submitReport = submitReport;
    window.SLB_CMR.emailJee = emailJee;

        // Pulse runtime code is parsed once in this file. Just trigger its boot now.
    try{
      if(typeof window.__SLB_CMR_PULSE_TRYBOOT__ === 'function'){
        window.__SLB_CMR_PULSE_TRYBOOT__();
      }
    }catch(_e){}
  }

  // ===== User CMR Tab =====
  var userState = { items:[], selected:'', cacheById:{}, editor:null, canEdit:false };

  async function loadMyList(force){
    try{
      var res = await rpc('cmrList', { limit: 240, includeRich: false });
      var out = res && (res.result || res);
      var items = (out && out.items) ? out.items : [];
      userState.items = items || [];
      return userState.items;
    }catch(e){
      throw e;
    }
  }

  function renderMyList(filter){
    filter = String(filter||'').trim().toUpperCase();
    var box = qs('#slbCmrMyList');
    if(!box) return;
    var items = (userState.items||[]);
    if(filter){
      items = items.filter(function(it){
        var dk = fmtDateKey_(it.dateKey||'');
        var when = fmtDateTime_(it.createdAt || it.updatedAt || '');
        var pv1 = String(it.preview||'');
        var tg = String(it.tag||'');
        return (dk + ' ' + when + ' ' + tg + ' ' + pv1).toUpperCase().indexOf(filter) >= 0;
      });
    }
    if(!items.length){
      box.innerHTML = '<div style="padding:12px;color:var(--muted);">No reports yet.</div>';
      return;
    }
    box.innerHTML = items.map(function(it){
      var id = String(it.entryId||it.entryID||it.id||'').trim();
      var dk = fmtDateKey_(it.dateKey||'');
      var d0 = toDate_(it.createdAt || it.updatedAt || '');
      var tm = d0 ? fmtHm_(d0) : '';
      var upIso = String(it.updatedAt||it.createdAt||'');
      var upAgo = timeAgo_(upIso);
      var upTxt = fmtDateTime_(upIso);
      var active = (id && id===userState.selected) ? ' is-active' : '';
      var pv = String(it.tag || '').replace(/\s+/g,' ').trim();
      return `<div class="slbCmrRow${active}" data-id="${esc(id)}">
        <div style="min-width:0;flex:1;">
          <div class="slbCmrMyRowTop">
            <div class="slbCmrMyRowWhen">${esc(dk)}${(String(it.tag||'').trim())?(' · <span class="slbCmrTagPill">'+esc(String(it.tag||'').trim())+'</span>'):''}${tm?(' · '+esc(tm)):''}</div>
            <div class="slbCmrMyRowPv">${pv?('<span class="slbCmrTagPill">'+esc(pv)+'</span>'):''}</div>
          </div>
          <div class="slbCmrMeta">${upAgo?('Updated '+esc(upAgo)):''}<\/div>
        </div>
        <div class="slbCmrMeta">›</div>
      </div>`;
    }).join('');
    qsa('.slbCmrRow', box).forEach(function(r){
      r.addEventListener('click', function(){
        var id = r.getAttribute('data-id')||'';
        openMy(id);
      });
    });
  }

  function setMyViewer(html){
    var v = qs('#slbCmrMyViewer');
    if(v) v.innerHTML = html;
  }

  async function openMy(entryId){
    entryId = String(entryId||'').trim();
    if(!entryId) return;

    userState.selected = entryId;
    renderMyList(qs('#slbCmrMySearch') ? qs('#slbCmrMySearch').value : '');
    setMyViewer('<div class="slbCmrViewerBody"><div class="slbCmrSmallNote">Loading...</div></div>');

    try{
      var res = await rpc('cmrGet', { entryId: entryId, includeRich: true });
      var out = res && (res.result || res);
      var it = out && (out.item || out.entry || out);
      if(!it || !it.entryId) throw new Error('Not found');
      userState.cacheById[entryId] = it;

      var dk = fmtDateKey_(it.dateKey||'');
      var d0 = toDate_(it.createdAt || it.updatedAt || '');
      var tm = d0 ? fmtHm_(d0) : '';
      var upIso = String(it.updatedAt||it.createdAt||'');
      var upAgo = timeAgo_(upIso);
      var upTxt = fmtDateTime_(upIso);

      var reportHtml = (it.bodyRich && String(it.bodyRich).trim()) ? String(it.bodyRich) : nl2br(String(it.body||''));
      var notesHtml = (it.notesRich && String(it.notesRich).trim()) ? String(it.notesRich) : nl2br(String(it.notes||''));
      var editorHtml = `
        <div style="border:1px solid var(--border); border-radius:14px; overflow:hidden; background:var(--slb-panel,#fff); padding:12px;">
          <div class="slbDiWriteGrid" style="padding-top:0;">
            <div class="slbDiField">
              <div class="slbDiLbl">Date</div>
              <input class="slbDiInput" type="text" value="${esc(dk)}${tm?(' · '+esc(tm)):''}" disabled>
            </div>
            <div class="slbDiField">
              <div class="slbDiLbl">Tag</div>
              <input class="slbDiInput" id="slbCmrTag" type="text" value="${esc(String(it.tag||''))}" placeholder="Optional">
            </div>
          </div>

          <div class="slbStdEditor" data-slbeditor="v1" id="slbCmrMyStdEditor">
            <div class="slbWysToolbar slbStdToolbar">
              <div class="slbWysRow">
                <div class="slbWysGroup">
                  <select class="inp" data-wys-heading style="width:160px;">
                    <option value="p">Paragraph</option>
                    <option value="h1">H1</option>
                    <option value="h2">H2</option>
                    <option value="h3">H3</option>
                    <option value="h4">H4</option>
                  </select>
                  <select class="inp" data-wys-size style="width:110px;">
                    <option value="12">12</option>
                    <option value="14" selected>14</option>
                    <option value="16">16</option>
                    <option value="18">18</option>
                    <option value="20">20</option>
                    <option value="24">24</option>
                    <option value="28">28</option>
                    <option value="32">32</option>
                    <option value="40">40</option>
                  </select>
                </div>

                <div class="slbWysGroup">
                  <button class="btn soft mini" type="button" data-wcmd="bold"><b>B</b></button>
                  <button class="btn soft mini" type="button" data-wcmd="italic"><i>I</i></button>
                  <button class="btn soft mini" type="button" data-wcmd="underline"><u>U</u></button>
                  <button class="btn soft mini" type="button" data-wcmd="strikeThrough"><s>S</s></button>
                </div>

                <div class="slbWysGroup">
                  <button class="btn soft mini" type="button" data-wcmd="insertUnorderedList" title="Bullet list">•</button>
                  <button class="btn soft mini" type="button" data-wcmd="insertOrderedList" title="Number list">1.</button>
                  <button class="btn soft mini" type="button" data-wcmd="justifyLeft" title="Align left">⟸</button>
                  <button class="btn soft mini" type="button" data-wcmd="justifyCenter" title="Align center">⇔</button>
                  <button class="btn soft mini" type="button" data-wcmd="justifyRight" title="Align right">⟹</button>
                  <button class="btn soft mini" type="button" data-wcmd="justifyFull" title="Justify">☰</button>
                  <button class="btn soft mini" type="button" data-wcmd="quote" title="Quote">❝</button>
                </div>
              </div>

              <div class="slbWysRow">
                <div class="slbWysGroup">
                  <button class="btn square mini" type="button" data-wcolor="#ef4444" style="background:#ef4444;color:#fff;">A</button>
                  <button class="btn square mini" type="button" data-wcolor="#f59e0b" style="background:#f59e0b;color:#fff;">A</button>
                  <button class="btn square mini" type="button" data-wcolor="#10b981" style="background:#10b981;color:#fff;">A</button>
                  <button class="btn square mini" type="button" data-wcolor="#3b82f6" style="background:#3b82f6;color:#fff;">A</button>
                  <button class="btn square mini" type="button" data-wcolor="#7c3aed" style="background:#7c3aed;color:#fff;">A</button>
                  <input type="color" class="inp" data-wys-colorpicker style="width:36px;padding:0;" />
                </div>

                <div class="slbWysGroup">
                  <button class="btn square mini" type="button" data-wbg="#fde68a" style="background:#fde68a;color:#000;">HL</button>
                  <button class="btn square mini" type="button" data-wbg="#bbf7d0" style="background:#bbf7d0;color:#000;">HL</button>
                  <button class="btn square mini" type="button" data-wbg="#bfdbfe" style="background:#bfdbfe;color:#000;">HL</button>
                  <button class="btn square mini" type="button" data-wbg="#fecaca" style="background:#fecaca;color:#000;">HL</button>
                  <button class="btn square mini" type="button" data-wbg="#f3e8ff" style="background:#f3e8ff;color:#000;">HL</button>
                  <input type="color" class="inp" data-wys-hlpicker style="width:36px;padding:0;" />
                </div>

                <div class="slbWysGroup slbEmojiWrap">
                  <button class="btn soft mini" type="button" data-wcmd="emoji" title="Emojis">🙂</button>
                  <div class="slbEmojiPanel hidden">
                    <button class="slbEmojiItem" type="button" data-emoji="😀">😀</button>
                    <button class="slbEmojiItem" type="button" data-emoji="😁">😁</button>
                    <button class="slbEmojiItem" type="button" data-emoji="😄">😄</button>
                    <button class="slbEmojiItem" type="button" data-emoji="😂">😂</button>
                    <button class="slbEmojiItem" type="button" data-emoji="🤣">🤣</button>
                    <button class="slbEmojiItem" type="button" data-emoji="🙂">🙂</button>
                    <button class="slbEmojiItem" type="button" data-emoji="😉">😉</button>
                    <button class="slbEmojiItem" type="button" data-emoji="😎">😎</button>
                    <button class="slbEmojiItem" type="button" data-emoji="🤔">🤔</button>
                    <button class="slbEmojiItem" type="button" data-emoji="😮">😮</button>
                    <button class="slbEmojiItem" type="button" data-emoji="😭">😭</button>
                    <button class="slbEmojiItem" type="button" data-emoji="😡">😡</button>
                    <button class="slbEmojiItem" type="button" data-emoji="👍">👍</button>
                    <button class="slbEmojiItem" type="button" data-emoji="👎">👎</button>
                    <button class="slbEmojiItem" type="button" data-emoji="🙏">🙏</button>
                    <button class="slbEmojiItem" type="button" data-emoji="✨">✨</button>
                    <button class="slbEmojiItem" type="button" data-emoji="⚡">⚡</button>
                    <button class="slbEmojiItem" type="button" data-emoji="❤️">❤️</button>
                    <button class="slbEmojiItem" type="button" data-emoji="💜">💜</button>
                    <button class="slbEmojiItem" type="button" data-emoji="🔥">🔥</button>
                    <button class="slbEmojiItem" type="button" data-emoji="🌙">🌙</button>
                    <button class="slbEmojiItem" type="button" data-emoji="⭐">⭐</button>
                    <button class="slbEmojiItem" type="button" data-emoji="✅">✅</button>
                    <button class="slbEmojiItem" type="button" data-emoji="❗">❗</button>
                    <button class="slbEmojiItem" type="button" data-emoji="💡">💡</button>
                    <button class="slbEmojiItem" type="button" data-emoji="📌">📌</button>
                    <button class="slbEmojiItem" type="button" data-emoji="🧧">🧧</button>
                    <button class="slbEmojiItem" type="button" data-emoji="🐉">🐉</button>
                    <button class="slbEmojiItem" type="button" data-emoji="☯️">☯️</button>
                    <button class="slbEmojiItem" type="button" data-emoji="🌀">🌀</button>
                    <button class="slbEmojiItem" type="button" data-emoji="🛡️">🛡️</button>
                    <button class="slbEmojiItem" type="button" data-emoji="🎯">🎯</button>
                    <button class="slbEmojiItem" type="button" data-emoji="📣">📣</button>
                    <button class="slbEmojiItem" type="button" data-emoji="🤝">🤝</button>
                    <button class="slbEmojiItem" type="button" data-emoji="🟠">🟠</button>
                    <button class="slbEmojiItem" type="button" data-emoji="⚔️">⚔️</button>
                  </div>
                </div>

                <div class="slbWysGroup slbWysEnd">
                  <button class="btn soft mini" type="button" data-wcmd="createLink" title="Link">🔗</button>
                  <button class="btn soft mini" type="button" data-wcmd="insertImage" title="Image">🖼️</button>
                  <button class="btn soft mini" type="button" data-wcmd="yt" title="YouTube">▶️</button>
                  <button class="btn soft mini square" type="button" data-wcmd="removeFormat" title="Clear formatting">✕</button>
                </div>
              </div>
            </div>

            <div class="slbCmrMyTwoCol">
              <div class="slbCmrMyCol">
                <div class="slbDiLbl slbCmrMyFieldLbl">Report</div>
                <div id="slbCmrMyWriteBody" class="richEditor slbStdArea" data-slbeditor-area contenteditable="true" spellcheck="true"></div>
              </div>
              <div class="slbCmrMyCol">
                <div class="slbDiLbl slbCmrMyFieldLbl">Note</div>
                <div id="slbCmrMyWriteNotes" class="richEditor slbStdArea" data-slbeditor-area contenteditable="true" spellcheck="true"></div>
              </div>
            </div>
          </div>
        </div>
      `;

      setMyViewer(`
        <div class="slbCmrViewerTop">
          <div>
            <div style="font-weight:900;">${esc(dk)}${tm?(' · '+esc(tm)):''}</div>
            <div class="slbCmrSmallNote">Updated: ${esc(upTxt)}${upAgo?(' ('+esc(upAgo)+')'):''}</div>
          </div>
          <div class="slbCmrSplitBtns">
            <button class="btn" id="slbCmrMyRefresh" type="button">Refresh</button>
            <button class="btn danger" id="slbCmrMyDelete" type="button">Delete</button>
          </div>
        </div>

        <div class="slbCmrViewerBody">
          ${editorHtml}
          <div class="slbCmrViewerActions">
            <button class="btn orange" id="slbCmrMySave" type="button">Save</button>
            <button class="btn danger" id="slbCmrMyEmail" type="button">&gt;&gt;Si Juen</button>
            <button class="btn navy" id="slbCmrMyMyself" type="button">&gt;&gt; MYSELF</button>
          </div>
        </div>
      `);

      // Global editor (Standard Editor V1) for Medical Records (Report + Notes)
      function safeUrlStd_(u){
        u = String(u||'').trim();
        if(!u) return '';
        var low = u.toLowerCase();
        if(low.indexOf('javascript:')===0 || low.indexOf('data:')===0 || low.indexOf('vbscript:')===0) return '';
        if(low.indexOf('http://')===0 || low.indexOf('https://')===0) return u;
        return '';
      }
      function sanitizeStyleStd_(style){
        style = String(style||'').trim();
        if(!style) return '';
        var allow = { 'color':1, 'background-color':1, 'font-size':1, 'text-decoration':1, 'font-weight':1, 'font-style':1, 'text-align':1 };
        var out = [];
        style.split(';').forEach(function(pair){
          var p = pair.split(':');
          if(p.length < 2) return;
          var k = String(p[0]||'').trim().toLowerCase();
          var v = String(p.slice(1).join(':')||'').trim();
          if(!allow[k] || !v) return;
          if(/url\s*\(/i.test(v)) return;
          if(k === 'font-size'){
            var m = v.match(/(\d{1,3})\s*px/i);
            if(!m) return;
            var n = Math.max(8, Math.min(48, parseInt(m[1],10)));
            v = n + 'px';
          }
          out.push(k + ':' + v);
        });
        return out.join(';');
      }
      function sanitizeRichHtmlStd_(html){
        html = String(html||'');
        if(!html.trim()) return '';
        var doc;
        try{ doc = new DOMParser().parseFromString('<div id="__wrap">' + html + '</div>', 'text/html'); }
        catch(_e){ return ''; }
        var wrap = doc.getElementById('__wrap');
        if(!wrap) return '';

        var allowed = { 'B':1,'STRONG':1,'I':1,'EM':1,'U':1,'S':1,'DEL':1,'STRIKE':1,'BR':1,'P':1,'DIV':1,'SPAN':1,'UL':1,'OL':1,'LI':1,'BLOCKQUOTE':1,'H1':1,'H2':1,'H3':1,'H4':1,'A':1,'IMG':1,'IFRAME':1 };
        var attrs = {
          'A': {'href':1,'target':1,'rel':1,'title':1},
          'IMG': {'src':1,'alt':1,'title':1,'width':1,'height':1,'loading':1},
          'SPAN': {'style':1},
          'DIV': {'style':1,'class':1},
          'P': {'style':1},
          'H1': {'style':1},
          'H2': {'style':1},
          'H3': {'style':1},
          'H4': {'style':1},
          'IFRAME': {'src':1,'width':1,'height':1,'title':1,'allow':1,'allowfullscreen':1,'frameborder':1,'loading':1,'referrerpolicy':1,'class':1}
        };

        (function walk(node){
          var kids = Array.from(node.childNodes || []);
          for(var i=0;i<kids.length;i++){
            var ch = kids[i];
            if(ch.nodeType === 1){
              var tag = ch.tagName;
              if(!allowed[tag]){
                var frag = doc.createDocumentFragment();
                while(ch.firstChild) frag.appendChild(ch.firstChild);
                ch.replaceWith(frag);
                continue;
              }

              var allowA = attrs[tag] || {};
              Array.from(ch.attributes || []).forEach(function(a){
                var name = String(a.name||'').toLowerCase();
                if(name.indexOf('on')===0){ ch.removeAttribute(a.name); return; }
                if(!allowA[a.name] && a.name !== 'style') ch.removeAttribute(a.name);
              });

              if(tag === 'A'){
                var href = safeUrlStd_(ch.getAttribute('href'));
                if(!href){
                  var frag2 = doc.createDocumentFragment();
                  while(ch.firstChild) frag2.appendChild(ch.firstChild);
                  ch.replaceWith(frag2);
                  continue;
                }
                ch.setAttribute('href', href);
                ch.setAttribute('target','_blank');
                ch.setAttribute('rel','noopener noreferrer');
              }
              if(tag === 'IMG'){
                var src = safeUrlStd_(ch.getAttribute('src'));
                if(!src){ ch.remove(); continue; }
                ch.setAttribute('src', src);
                ch.setAttribute('loading', 'lazy');
                ch.removeAttribute('srcset');
              }
              if(tag === 'IFRAME'){
                var src2 = safeUrlStd_(ch.getAttribute('src'));
                if(!src2){ ch.remove(); continue; }
                ch.setAttribute('src', src2);
                ch.setAttribute('loading', 'lazy');
                ch.removeAttribute('srcdoc');
              }

              if(ch.hasAttribute('style')){
                var s = sanitizeStyleStd_(ch.getAttribute('style'));
                if(s) ch.setAttribute('style', s);
                else ch.removeAttribute('style');
              }

              walk(ch);
            }else if(ch.nodeType === 8){
              ch.remove();
            }
          }
        })(wrap);

        return wrap.innerHTML;
      }
      function htmlToTextStd_(html){
        try{
          var d = document.createElement('div');
          d.innerHTML = String(html||'');
          return String(d.textContent||'').replace(/\s+$/,'');
        }catch(_e){
          return String(html||'');
        }
      }

      var stdRoot = qs('#slbCmrMyStdEditor');
      try{
        if(window.SLB_STD_EDITOR_V1 && typeof window.SLB_STD_EDITOR_V1.bind === 'function'){
          if(stdRoot) window.SLB_STD_EDITOR_V1.bind(stdRoot);
        }
      }catch(_e){}

      var repArea = qs('#slbCmrMyWriteBody');
      var notArea = qs('#slbCmrMyWriteNotes');
      if(repArea) repArea.innerHTML = sanitizeRichHtmlStd_(reportHtml);
      if(notArea) notArea.innerHTML = sanitizeRichHtmlStd_(notesHtml);

      userState.editor = {
        setReportHtml: function(h){ if(repArea) repArea.innerHTML = sanitizeRichHtmlStd_(h||''); },
        getReportHtml: function(){ return sanitizeRichHtmlStd_(repArea ? repArea.innerHTML : ''); },
        getReportText: function(){ return htmlToTextStd_(repArea ? repArea.innerHTML : ''); },
        focusReport: function(){ try{ repArea && repArea.focus(); }catch(_e){} },

        setNotesHtml: function(h){ if(notArea) notArea.innerHTML = sanitizeRichHtmlStd_(h||''); },
        getNotesHtml: function(){ return sanitizeRichHtmlStd_(notArea ? notArea.innerHTML : ''); },
        getNotesText: function(){ return htmlToTextStd_(notArea ? notArea.innerHTML : ''); },
        focusNotes: function(){ try{ notArea && notArea.focus(); }catch(_e){} }
      };

      var btnR = qs('#slbCmrMyRefresh');
      if(btnR){
        btnR.addEventListener('click', async function(){
          await reloadMyListAndKeep(entryId, true);
        });
      }

      var btnSave = qs('#slbCmrMySave');
      if(btnSave){
        btnSave.addEventListener('click', async function(){
          try{
            btnSave.disabled = true;
            var hR = userState.editor ? userState.editor.getReportHtml() : '';
            var tR = userState.editor ? userState.editor.getReportText() : '';
            var hN = userState.editor ? userState.editor.getNotesHtml() : '';
            var tN = userState.editor ? userState.editor.getNotesText() : '';
            var tagV = '';
            try{ var tagEl = document.getElementById('slbCmrTag'); tagV = (tagEl && tagEl.value) ? String(tagEl.value) : ''; }catch(e){}
            tagV = String(tagV||'').trim();
            await rpc('cmrUpsert', { entryId: entryId, dateKey: String(it.dateKey||''), tag: tagV, body: tR, bodyRich: hR, notes: tN, notesRich: hN });
            toast('Saved.');
            await reloadMyListAndKeep(entryId, true);
          }catch(e){ toast('Save failed.'); }
          finally{ btnSave.disabled=false; }
        });
      }

      var btnE = qs('#slbCmrMyEmail');
      if(btnE){
        btnE.addEventListener('click', async function(){
          try{
            btnE.disabled = true;

            // Save first (so email matches what you see)
            var hR = userState.editor ? userState.editor.getReportHtml() : '';
            var tR = userState.editor ? userState.editor.getReportText() : '';
            var hN = userState.editor ? userState.editor.getNotesHtml() : '';
            var tN = userState.editor ? userState.editor.getNotesText() : '';
            var tagV = '';
            try{ var tagEl = document.getElementById('slbCmrTag'); tagV = (tagEl && tagEl.value) ? String(tagEl.value) : ''; }catch(e){}
            tagV = String(tagV||'').trim();
            await rpc('cmrUpsert', { entryId: entryId, dateKey: String(it.dateKey||''), tag: tagV, body: tR, bodyRich: hR, notes: tN, notesRich: hN });

            var emailBody = [
              'CMR REPORT ENTRY',
              'Callsign: ' + String(getRole().callsign||''),
              'Date: ' + dk + (tm?(' ' + tm):''),
              'Updated: ' + upTxt,
              '',
              '--- REPORT ---',
              tR || '(empty)',
              '',
              '--- NOTES ---',
              tN || '(empty)'
            ].join('\n');

            toast('Emailing...');
            await rpc('cmrEmailJee', { entryId: entryId, dateKey: dk, updatedAt: upTxt, reportHtml: hR, reportText: tR, notesHtml: hN, notesText: tN });
            toast('Email sent.');
          }catch(e){ toast('Email failed.'); }
          finally{ btnE.disabled = false; }
        });
      }

      
      var btnSelf = qs('#slbCmrMyMyself');
      if(btnSelf){
        btnSelf.addEventListener('click', async function(){
          try{
            btnSelf.disabled = true;

            // Save first (so email matches what you see)
            var hR = userState.editor ? userState.editor.getReportHtml() : '';
            var tR = userState.editor ? userState.editor.getReportText() : '';
            var hN = userState.editor ? userState.editor.getNotesHtml() : '';
            var tN = userState.editor ? userState.editor.getNotesText() : '';
            await rpc('cmrUpsert', { entryId: entryId, dateKey: dk, body: tR, bodyRich: hR, notes: tN, notesRich: hN });

            await rpc('cmrEmailMyself', { entryId: entryId, dateKey: dk, updatedAt: upTxt, reportHtml: hR, reportText: tR, notesHtml: hN, notesText: tN });
            toast('Email sent.');
          }catch(e){ toast('Email failed.'); }
          finally{ btnSelf.disabled = false; }
        });
      }


      var btnD = qs('#slbCmrMyDelete');
      if(btnD){
        btnD.addEventListener('click', async function(){
          if(!confirm('Delete this CMR entry? This cannot be undone.')) return;
          try{
            btnD.disabled = true;
            await rpc('cmrDelete', { entryId: entryId });
            toast('Deleted.');
            await loadMyList(true);
            renderMyList(qs('#slbCmrMySearch') ? qs('#slbCmrMySearch').value : '');
            var first = (userState.items && userState.items.length) ? userState.items[0] : null;
            if(first && first.entryId){ await openMy(first.entryId); }
            else{ setMyViewer('<div class="slbCmrViewerBody"><div class="slbCmrSmallNote">No reports yet.</div></div>'); }
          }catch(e){ toast('Delete failed.'); }
          finally{ btnD.disabled = false; }
        });
      }

    }catch(e){
      setMyViewer('<div class="slbCmrViewerBody"><div class="slbCmrSmallNote">Failed to load. ' + esc((e && e.message) ? e.message : '') + '</div></div>');
    }
  }

  async function reloadMyListAndKeep(entryId, forceOpen){
    try{
      await loadMyList(true);
      renderMyList(qs('#slbCmrMySearch') ? qs('#slbCmrMySearch').value : '');
      if(forceOpen) await openMy(entryId);
    }catch(_e){}
  }
  async function submitReport(reportText){
    var body = String(reportText||'').trim();
    if(!body){ toast('No report yet.'); return; }
    var res = await rpc('cmrUpsert', { body: body, bodyRich: '', notes: '', notesRich: '' });
    var out = res && (res.result || res);
    var id = (out && out.entryId) ? String(out.entryId) : '';
    toast('CMR saved.');
    await loadMyList(true);
    renderMyList(qs('#slbCmrMySearch') ? qs('#slbCmrMySearch').value : '');
    if(id) openMy(id);
    return out;
  }

  async function emailJee(payload){
    try{
      payload = payload || {};
      var report = String(payload.report || payload.body || '').trim();
      if(!report){ toast('No report yet.'); return; }
      var meta = payload.meta || {};
      var res = await rpc('cmrEmailJee', {
        body: report,
        meta: meta,
        mode: String(payload.mode||''),
        selfName: String(payload.selfName||''),
        doctorName: String(payload.doctorName||''),
        patientName: String(payload.patientName||''),
        problem: String(payload.problem||''),
        specialNote: String(payload.specialNote||'')
      });
      var out = res && (res.result || res);
      toast('Email sent.');
      return out;
    }catch(e){
      toast('Email failed.');
      throw e;
    }
  }

  function syncIdentityFields_(){
    try{
      var role = getRole();
      if(!role || !role.callsign) return false;
      var cs = String(role.callsign||'').trim().toUpperCase();
      var self = document.getElementById('tycmSelfName');
      if(self && (!self.value || self.dataset.autoFill === '1')){
        self.value = cs;
        self.dataset.autoFill = '1';
      }
      var doc = document.getElementById('tycmDoctorName');
      if(doc && (!doc.value || doc.dataset.autoFill === '1')){
        doc.value = cs;
        doc.dataset.autoFill = '1';
      }
      return true;
    }catch(_e){
      return false;
    }
  }

  function hookModeAutofill_(){
    try{
      var radios = document.querySelectorAll('input[name="tycmMode"]');
      if(!radios || !radios.length) return;
      radios.forEach(function(r){
        if(r.__slbCmrHooked) return;
        r.__slbCmrHooked = true;
        r.addEventListener('change', function(){
          if(r.checked) syncIdentityFields_();
        });
      });
    }catch(_e){}
  }

async function bootUser(){
    var panel = document.getElementById('slbCmrPanel');
    if(!panel) return;

    // Already booted: keep identity in sync if pulse tool has been mounted.
    if(panel.dataset && panel.dataset.slbBooted === '1'){
      try{
        if(panel.dataset.slbPulseMounted === '1'){
          hookModeAutofill_();
          syncIdentityFields_();
        }
      }catch(_e){}
      return;
    }

    if(panel.dataset) panel.dataset.slbBooted = '1';

    // Tabs-only feel: show just 2 collapsible choices on entry.
    panel.innerHTML = `
      <div class="slbCmrAcc">
        <details class="slbCmrDetails" id="slbCmrPulseBox" open>
          <summary class="slbCmrSummary">
            <div class="slbCmrSumLeft">
              <div class="slbCmrSumTitle">Diagnose</div>
            </div>
            <div class="slbCmrSumRight">
              </div>
          </summary>
          <div class="slbCmrBody">
            <div id="slbCmrToolMount"></div>

            <div class="slbCmrOut">
              <textarea id="slbCmrNotesText" class="slbCmrNotesText" placeholder="Note (optional)"></textarea>

              <div class="slbCmrBtnRow">
                <button type="button" class="btn" id="slbCmrClear">CLEAR</button>
                <button type="button" class="btn primary" id="slbCmrFinalize">FINALIZE</button>
              </div>

              <div class="slbCmrTagRow">
                <input id="slbCmrDraftTag" class="slbCmrTagInput" placeholder="Tag (optional)" autocomplete="off">
              </div>

<div class="slbStdEditor" data-slbeditor="v1" id="slbCmrStdEditor" data-slbeditor-height="360">
                <div class="slbWysToolbar slbStdToolbar">
                  <div class="slbWysRow">
                    <div class="slbWysGroup">
                      <select class="inp" data-wys-heading style="width:160px;">
                        <option value="p">Paragraph</option>
                        <option value="h1">H1</option>
                        <option value="h2">H2</option>
                        <option value="h3">H3</option>
                        <option value="h4">H4</option>
                      </select>
                      <select class="inp" data-wys-size style="width:110px;">
                        <option value="12">12</option>
                        <option value="14" selected>14</option>
                        <option value="16">16</option>
                        <option value="18">18</option>
                        <option value="20">20</option>
                        <option value="24">24</option>
                        <option value="28">28</option>
                        <option value="32">32</option>
                        <option value="40">40</option>
                      </select>
                    </div>

                    <div class="slbWysGroup">
                      <button class="btn soft mini" type="button" data-wcmd="bold"><b>B</b></button>
                      <button class="btn soft mini" type="button" data-wcmd="italic"><i>I</i></button>
                      <button class="btn soft mini" type="button" data-wcmd="underline"><u>U</u></button>
                      <button class="btn soft mini" type="button" data-wcmd="strikeThrough"><s>S</s></button>
                    </div>

                    <div class="slbWysGroup">
                      <button class="btn soft mini" type="button" data-wcmd="insertUnorderedList" title="Bullet list">•</button>
                      <button class="btn soft mini" type="button" data-wcmd="insertOrderedList" title="Number list">1.</button>
                      <button class="btn soft mini" type="button" data-wcmd="justifyLeft" title="Align left">⟸</button>
                      <button class="btn soft mini" type="button" data-wcmd="justifyCenter" title="Align center">⇔</button>
                      <button class="btn soft mini" type="button" data-wcmd="justifyRight" title="Align right">⟹</button>
                      <button class="btn soft mini" type="button" data-wcmd="justifyFull" title="Justify">☰</button>
                      <button class="btn soft mini" type="button" data-wcmd="quote" title="Quote">❝</button>
                    </div>
                  </div>

                  <div class="slbWysRow">
                    <div class="slbWysGroup">
                      <button class="btn square mini" type="button" data-wcolor="#ef4444" style="background:#ef4444;color:#fff;">A</button>
                      <button class="btn square mini" type="button" data-wcolor="#f59e0b" style="background:#f59e0b;color:#fff;">A</button>
                      <button class="btn square mini" type="button" data-wcolor="#10b981" style="background:#10b981;color:#fff;">A</button>
                      <button class="btn square mini" type="button" data-wcolor="#3b82f6" style="background:#3b82f6;color:#fff;">A</button>
                      <button class="btn square mini" type="button" data-wcolor="#7c3aed" style="background:#7c3aed;color:#fff;">A</button>
                      <input type="color" class="inp" data-wys-colorpicker style="width:36px;padding:0;" />
                    </div>

                    <div class="slbWysGroup">
                      <button class="btn square mini" type="button" data-wbg="#fde68a" style="background:#fde68a;color:#000;">HL</button>
                      <button class="btn square mini" type="button" data-wbg="#bbf7d0" style="background:#bbf7d0;color:#000;">HL</button>
                      <button class="btn square mini" type="button" data-wbg="#bfdbfe" style="background:#bfdbfe;color:#000;">HL</button>
                      <button class="btn square mini" type="button" data-wbg="#fecaca" style="background:#fecaca;color:#000;">HL</button>
                      <button class="btn square mini" type="button" data-wbg="#f3e8ff" style="background:#f3e8ff;color:#000;">HL</button>
                      <input type="color" class="inp" data-wys-hlpicker style="width:36px;padding:0;" />
                    </div>

                    <div class="slbWysGroup slbEmojiWrap">
                      <button class="btn soft mini" type="button" data-wcmd="emoji" title="Emojis">🙂</button>
                      <div class="slbEmojiPanel hidden">
                        <button class="slbEmojiItem" type="button" data-emoji="😀">😀</button>
                        <button class="slbEmojiItem" type="button" data-emoji="😁">😁</button>
                        <button class="slbEmojiItem" type="button" data-emoji="😄">😄</button>
                        <button class="slbEmojiItem" type="button" data-emoji="😂">😂</button>
                        <button class="slbEmojiItem" type="button" data-emoji="🤣">🤣</button>
                        <button class="slbEmojiItem" type="button" data-emoji="🙂">🙂</button>
                        <button class="slbEmojiItem" type="button" data-emoji="😉">😉</button>
                        <button class="slbEmojiItem" type="button" data-emoji="😎">😎</button>
                        <button class="slbEmojiItem" type="button" data-emoji="🤔">🤔</button>
                        <button class="slbEmojiItem" type="button" data-emoji="😮">😮</button>
                        <button class="slbEmojiItem" type="button" data-emoji="😭">😭</button>
                        <button class="slbEmojiItem" type="button" data-emoji="😡">😡</button>
                        <button class="slbEmojiItem" type="button" data-emoji="👍">👍</button>
                        <button class="slbEmojiItem" type="button" data-emoji="👎">👎</button>
                        <button class="slbEmojiItem" type="button" data-emoji="🙏">🙏</button>
                        <button class="slbEmojiItem" type="button" data-emoji="✨">✨</button>
                        <button class="slbEmojiItem" type="button" data-emoji="⚡">⚡</button>
                        <button class="slbEmojiItem" type="button" data-emoji="❤️">❤️</button>
                        <button class="slbEmojiItem" type="button" data-emoji="💜">💜</button>
                        <button class="slbEmojiItem" type="button" data-emoji="🔥">🔥</button>
                        <button class="slbEmojiItem" type="button" data-emoji="🌙">🌙</button>
                        <button class="slbEmojiItem" type="button" data-emoji="⭐">⭐</button>
                        <button class="slbEmojiItem" type="button" data-emoji="✅">✅</button>
                        <button class="slbEmojiItem" type="button" data-emoji="❗">❗</button>
                        <button class="slbEmojiItem" type="button" data-emoji="💡">💡</button>
                        <button class="slbEmojiItem" type="button" data-emoji="📌">📌</button>
                        <button class="slbEmojiItem" type="button" data-emoji="🧧">🧧</button>
                        <button class="slbEmojiItem" type="button" data-emoji="🐉">🐉</button>
                        <button class="slbEmojiItem" type="button" data-emoji="☯️">☯️</button>
                        <button class="slbEmojiItem" type="button" data-emoji="🌀">🌀</button>
                        <button class="slbEmojiItem" type="button" data-emoji="🛡️">🛡️</button>
                        <button class="slbEmojiItem" type="button" data-emoji="🎯">🎯</button>
                        <button class="slbEmojiItem" type="button" data-emoji="📣">📣</button>
                        <button class="slbEmojiItem" type="button" data-emoji="🤝">🤝</button>
                        <button class="slbEmojiItem" type="button" data-emoji="🟠">🟠</button>
                        <button class="slbEmojiItem" type="button" data-emoji="⚔️">⚔️</button>
                      </div>
                    </div>

                    <div class="slbWysGroup slbWysEnd">
                      <button class="btn soft mini" type="button" data-wcmd="createLink" title="Link">🔗</button>
                      <button class="btn soft mini" type="button" data-wcmd="insertImage" title="Image">🖼️</button>
                      <button class="btn soft mini" type="button" data-wcmd="yt" title="YouTube">▶️</button>
                      <button class="btn soft mini square" type="button" data-wcmd="removeFormat" title="Clear formatting">✕</button>
                    </div>
                  </div>
                </div>

                <div class="richEditor slbStdArea" data-slbeditor-area contenteditable="true" spellcheck="true" id="slbCmrFinalRich"></div>
              </div>

              <div class="slbCmrBtnRow slbCmrSaveRow">
                <button type="button" class="btn primary" id="slbCmrSave">SAVE</button>
                <button type="button" class="btn email" id="slbCmrEmailJee">&gt;&gt; Si Juen</button>
              </div>
            </div>
          </div>
        </details>

        <details class="slbCmrDetails" id="slbCmrReportsBox">
          <summary class="slbCmrSummary">
            <div class="slbCmrSumLeft">
              <div class="slbCmrSumTitle">Medical Records</div>
            </div>
            <div class="slbCmrSumRight">
              
            </div>
          </summary>
          <div class="slbCmrBody" id="slbCmrReportsMount"></div>
        </details>
      </div>
    `;

    function ensurePulseUI_(){
      if(panel.dataset && panel.dataset.slbPulseMounted === '1') return;
      if(panel.dataset) panel.dataset.slbPulseMounted = '1';

      var mountEl = qs('#slbCmrToolMount', panel);
      if(mountEl) mountPulseTool(mountEl);

      // Auto-fill names (if user is logged in)
      hookModeAutofill_();
      if(!syncIdentityFields_()){
        var tries = 0;
        (function retry(){
          tries++;
          if(syncIdentityFields_() || tries > 20) return;
          setTimeout(retry, 250);
        })();
      }

      wireDiagnoseUI_();
    }

    function wireDiagnoseUI_(){
      if(panel.dataset && panel.dataset.slbCmrDiagWired === '1') return;
      if(panel.dataset) panel.dataset.slbCmrDiagWired = '1';

      var notesEl = qs('#slbCmrNotesText', panel);
      var tagEl = qs('#slbCmrDraftTag', panel);
      var stdRoot = qs('#slbCmrStdEditor', panel);
      var richEl = qs('#slbCmrFinalRich', panel);

      // Bind global rich editor (StdEditor V1)
      try{
        if(stdRoot && window.SLB_STD_EDITOR_V1 && typeof window.SLB_STD_EDITOR_V1.bind === 'function'){
          window.SLB_STD_EDITOR_V1.bind(stdRoot);
        }
      }catch(_e){}

      var btnClear = qs('#slbCmrClear', panel);
      var btnFinalize = qs('#slbCmrFinalize', panel);
      var btnSave = qs('#slbCmrSave', panel);
      var btnEmail = qs('#slbCmrEmailJee', panel);

      function setBusy(btn, busy){
        if(!btn) return;
        btn.disabled = !!busy;
        try{
          if(window.SLB && window.SLB.ui && typeof window.SLB.ui.setBusy==='function'){
            window.SLB.ui.setBusy(btn, !!busy);
          }
        }catch(_e){}
      }
      function setBusyRow(busy){
        setBusy(btnClear, busy);
        setBusy(btnFinalize, busy);
        setBusy(btnSave, busy);
        setBusy(btnEmail, busy);
      }

      function localDateKey_(){
        var d = new Date();
        var mm = String(d.getMonth() + 1).padStart(2,'0');
        var dd = String(d.getDate()).padStart(2,'0');
        return d.getFullYear() + '-' + mm + '-' + dd;
      }

      function clearDraft_(quiet){
        var didToolClear = false;
        try{
          if(window.TYCM_API && typeof window.TYCM_API.clearAll === 'function'){
            window.TYCM_API.clearAll();
            didToolClear = true;
          }
          else{
            try{ var cb = document.getElementById('tycmClearBtn'); if(cb) { cb.click(); didToolClear = true; } }catch(__e){}
          }
        }catch(_e){}
        if(notesEl) notesEl.value = '';
        if(tagEl) tagEl.value = '';
        if(richEl) richEl.innerHTML = '';
        if(panel.dataset) panel.dataset.slbCmrDraftEntryId = '';
        if(!quiet && !didToolClear) toast('Cleared.');
      }

      async function finalizeDraft_(){
        setBusyRow(true);
        try{
          var noteText = notesEl ? String(notesEl.value || '') : '';
          var reportText = '';

          // Primary: use tool API (fast, no UI needed)
          try{
            if(window.TYCM_API && typeof window.TYCM_API.buildReport === 'function'){
              reportText = String(window.TYCM_API.buildReport(noteText) || '').trim();
            }
          }catch(_e){}

          // Fallback: trigger tool finalize and read output textarea
          if(!reportText){
            try{
              try{ var sn = document.getElementById('tycmSpecialNote'); if(sn) sn.value = noteText; }catch(__e){}
              var fbtn = document.getElementById('tycmFinalizeBtn');
              if(fbtn) fbtn.click();
              var out = document.getElementById('tycmReportOutput');
              reportText = (out && out.value) ? String(out.value).trim() : '';
            }catch(_e){}
          }

          if(!reportText){
            toast('No report yet. Please complete the pulse toggles then FINALIZE.');
            return;
          }

          if(richEl){
            var safe = esc(String(reportText||'').replace(/\r\n/g,'\n'));
            safe = safe.replace(/\n/g,'<br>');
            richEl.innerHTML = '<div class="slbCmrReportText">' + safe + '</div>';
          }

          toast('Finalized.');
          try{
            if(stdRoot) stdRoot.scrollIntoView({ behavior:'smooth', block:'start' });
          }catch(_e){}
        }finally{
          setBusyRow(false);
        }
      }

      async function saveDraft_(opts){
        opts = opts || {};
        var sendEmail = !!opts.sendEmail;

        setBusyRow(true);
        toast('Saving...');
        try{
          ensureReportsUI_(); // ensure record UI exists (safe)

          var tag = tagEl ? String(tagEl.value || '').trim() : '';
          var noteText = notesEl ? String(notesEl.value || '').trim() : '';

          var bodyRich = richEl ? sanitizeRichHtml(richEl.innerHTML || '') : '';
          var body = '';
          try{ body = richEl ? String(richEl.innerText || '').trim() : ''; }catch(_e){}
          if(!body && bodyRich){
            try{ body = String(htmlToText(bodyRich) || '').trim(); }catch(_e){}
          }

          if(!body){
            toast('Nothing to save. Press FINALIZE first.');
            return;
          }

          var notesRich = noteText ? ('<div class="slbCmrNoteRich">' + esc(String(noteText||'').replace(/\r\n/g,'\n')).replace(/\n/g,'<br>') + '</div>') : '';
          var entryId = (panel.dataset && panel.dataset.slbCmrDraftEntryId) ? String(panel.dataset.slbCmrDraftEntryId || '') : '';

          var up = await rpc('cmrUpsert', {
            entryId: entryId || undefined,
            dateKey: localDateKey_(),
            tag: tag,
            body: body,
            bodyRich: bodyRich,
            notes: noteText,
            notesRich: notesRich
          });

          if(up && up.entryId && panel.dataset) panel.dataset.slbCmrDraftEntryId = up.entryId;

          if(sendEmail){
            var payload = {};
            try{
              if(window.TYCM_API && typeof window.TYCM_API.getEmailPayload === 'function'){
                payload = window.TYCM_API.getEmailPayload(noteText) || {};
              }
            }catch(_e){}
            payload = payload || {};
            // Ensure backend-compatible fields
            payload.reportText = body;
            payload.report = body; // legacy alias
            payload.reportHtml = bodyRich;
            payload.body = body;
            payload.bodyRich = bodyRich;
            payload.notesText = noteText;
            payload.notes = noteText; // legacy alias
            payload.notesHtml = notesRich;
            payload.notesRich = notesRich;
            payload.dateKey = localDateKey_();
            payload.tag = tag;
            payload.entryId = (up && up.entryId) ? up.entryId : (payload.entryId || entryId || '');
            toast('Sending to Si Juen...');
            await rpc('cmrEmailJee', payload);
            toast('Sent to Si Juen.');
          }else{
            toast('Saved.');
          }
          try{ loadMyList(true); }catch(_e){}
}catch(e){
          toast('Failed. ' + (e && e.message ? e.message : ''));
        }finally{
          setBusyRow(false);
        }
      }

      if(btnClear) btnClear.addEventListener('click', function(){ clearDraft_(false); });
      if(btnFinalize) btnFinalize.addEventListener('click', function(){ finalizeDraft_(); });
      if(btnSave) btnSave.addEventListener('click', function(){ saveDraft_({ sendEmail: false }); });
      if(btnEmail) btnEmail.addEventListener('click', function(){ saveDraft_({ sendEmail: true }); });

    }

    function ensureReportsUI_(){
      if(panel.dataset && panel.dataset.slbReportsMounted === '1') return;
      if(panel.dataset) panel.dataset.slbReportsMounted = '1';

      var mount = qs('#slbCmrReportsMount', panel);
      if(!mount) return;

      mount.innerHTML = `
        <div class="slbCmrMyWrap">
          <div class="slbCmrMyTop">
            <div class="slbCmrLeftTop">
              <input id="slbCmrMySearch" class="slbCmrSearch" placeholder="Filter by date (YYYY-MM-DD)..." autocomplete="off">
            </div>
            <div id="slbCmrMyList" class="slbCmrList slbCmrMyList"></div>
          </div>

          <div class="slbCmrMyBottom">
            <div class="slbCmrRight" id="slbCmrMyViewer">
              <div class="slbCmrViewerBody">
                <div class="slbCmrSmallNote">Select a date above.</div>
              </div>
            </div>
          </div>
        </div>
      `;

      var search = qs('#slbCmrMySearch');
      if(search){
        var t=null;
        search.addEventListener('input', function(){
          clearTimeout(t);
          t = setTimeout(function(){
            renderMyList(search.value);
          }, 120);
        });
      }
    }

    // Refresh (quiet) - keep it as a subtle icon in the Pulse header.
    var refreshBtn = qs('#slbCmrRefreshAll', panel);
    if(refreshBtn){
      refreshBtn.addEventListener('click', async function(e){
        e.preventDefault();
        e.stopPropagation();
        try{
          refreshBtn.disabled = true;
          await loadMyList(true);
          if(panel.dataset && panel.dataset.slbReportsMounted === '1'){
            renderMyList(qs('#slbCmrMySearch') ? qs('#slbCmrMySearch').value : '');
          }
          toast('Refreshed.');
        }catch(_e){
          toast('Refresh failed.');
        }finally{
          refreshBtn.disabled = false;
        }
      });
    }

    // Lazy mount for speed.
    var dPulse = qs('#slbCmrPulseBox', panel);
    if(dPulse){
      dPulse.addEventListener('toggle', function(){
        if(dPulse.open) ensurePulseUI_();
      });
    }

    
    // If the box is open by default, mount immediately.
    if(dPulse && dPulse.open){ setTimeout(function(){ try{ ensurePulseUI_(); }catch(_e){} }, 0); }
var dRep = qs('#slbCmrReportsBox', panel);
    if(dRep){
      dRep.addEventListener('toggle', async function(){
        if(!dRep.open) return;

        ensureReportsUI_();

        try{
          // If we already prefetched, render instantly.
          if(!userState || !userState.listLoaded){
            await loadMyList(false);
            if(userState) userState.listLoaded = true;
          }
          renderMyList(qs('#slbCmrMySearch') ? qs('#slbCmrMySearch').value : '');

          // Auto-open first record for convenience
          if(userState && userState.items && userState.items.length && !userState.selected){
            openMy(userState.items[0].id);
          }
        }catch(_e){
          var box = qs('#slbCmrMyList');
          if(box) box.innerHTML = `<div class="slbCmrSmallNote">Failed to load.</div>`;
        }
      });
    }

    // Background prefetch (quiet)
    setTimeout(async function(){
      try{
        await loadMyList(false);
        if(userState) userState.listLoaded = true;
      }catch(_e){}
    }, 80);
  }

  // ===== Admin CMR Inbox =====
  var inboxState = { disciples:[], statsBy:{}, selected:'', listCache:{}, entryCache:{} };
  function setInboxViewer(html){ var v=qs('#slbCmrViewer'); if(v) v.innerHTML = html; }
  function setInboxListHtml(html){ var v=qs('#slbCmrList'); if(v) v.innerHTML = html; }

  function parseDateSafe(s){ try{ var d=new Date(s); if(isNaN(d.getTime())) return null; return d; }catch(_e){ return null; } }

  async function refreshInboxStats(){
    try{
      var calls = (inboxState.disciples||[]).map(function(d){ return String(d.callsign||'').toUpperCase(); }).filter(Boolean);
      if(!calls.length) return;
      var res = await rpc('cmrInboxStats', { callsigns: calls });
      var out = res && (res.result || res);
      var items = (out && (out.items || out.stats)) ? (out.items || out.stats) : [];
      var map = {};
      (items||[]).forEach(function(x){
        var cs = String(x.callsign||'').toUpperCase();
        if(!cs) return;
        var up = String(x.lastUpdatedAt||x.updatedAt||'').trim();
        var dk = String(x.lastDateKey||x.dateKey||'').trim();
        if(!up && !dk) return;
        map[cs] = { lastUpdatedAt: up, lastDateKey: dk, lastEntryId: String(x.lastEntryId||x.entryId||''), count: (x.count!=null?x.count:null) };
      });
      inboxState.statsBy = map;
    }catch(_e){}
  }

  function renderInboxLeft(filter){
    filter = String(filter||'').trim().toUpperCase();
    var list = (inboxState.disciples||[]);

    // Only show callsigns that have at least 1 CMR record (like diary read)
    list = list.filter(function(d){
      var cs = String(d.callsign||'').toUpperCase();
      return !!(cs && inboxState.statsBy && inboxState.statsBy[cs]);
    });

    if(filter){
      list = list.filter(function(d){
        var cs = String(d.callsign||'');
        var dn = String(d.displayName||'');
        return cs.toUpperCase().indexOf(filter)>=0 || dn.toUpperCase().indexOf(filter)>=0;
      });
    }

    // Sort by last updated desc
    list = list.slice().sort(function(a,b){
      var sa = inboxState.statsBy[String(a.callsign||'').toUpperCase()] || {};
      var sb = inboxState.statsBy[String(b.callsign||'').toUpperCase()] || {};
      var ta = sa.lastUpdatedAt ? (parseDateSafe(sa.lastUpdatedAt)||{getTime:function(){return 0;}}).getTime() : 0;
      var tb = sb.lastUpdatedAt ? (parseDateSafe(sb.lastUpdatedAt)||{getTime:function(){return 0;}}).getTime() : 0;
      if(tb !== ta) return tb - ta;
      return String(a.callsign||'').localeCompare(String(b.callsign||''));
    });

    setInboxListHtml(list.map(function(d){
      var cs = String(d.callsign||'').toUpperCase();
      var dn = String(d.displayName||'').trim();
      var st = inboxState.statsBy[cs] || {};
      var up = String(st.lastUpdatedAt||'');
      var dk = String(st.lastDateKey||'');
      var cnt = (st.count!=null) ? String(st.count) : '';
      var upAgo = timeAgo_(up);
      var upTxt = fmtDateTime_(up);
      var active = (cs===inboxState.selected) ? ' is-active' : '';
      return `<div class="slbCmrRow${active}" data-cs="${esc(cs)}">
        <div>
          <div style="font-weight:900;">${esc(cs)}${dn?(' · '+esc(dn)):''}</div>
          <div class="slbCmrMeta">${cnt?('Reports: '+esc(cnt)+' · '):''}${dk?('Latest: '+esc(fmtDateKey_(dk))+' · '):''}${upAgo?('Last updated '+esc(upAgo)+' · '):''}${esc(upTxt)}</div>
        </div>
        <div class="slbCmrMeta">›</div>
      </div>`;
    }).join('') || '<div style="padding:12px;color:var(--muted);">No reports.</div>');

    qsa('.slbCmrRow', qs('#slbCmrList') ).forEach(function(r){
      r.addEventListener('click', function(){ selectDisciple(r.getAttribute('data-cs')); });
    });
  }

  async function loadEntriesFor(cs, force){
    cs = String(cs||'').toUpperCase();
    if(!force && inboxState.listCache[cs]) return inboxState.listCache[cs];
    var res = await rpc('cmrList', { callsign: cs, limit: 240, includeRich: false });
    var out = res && (res.result || res);
    var items = (out && out.items) ? out.items : [];
    inboxState.listCache[cs] = items;
    return items;
  }

  function buildInboxViewerShell(cs){
    return `
      <div class="slbCmrViewerTop">
        <div>
          <div style="font-weight:900;">${esc(cs)}</div>
          <div class="slbCmrSmallNote">Select a report below.</div>
        </div>
        <div class="slbCmrSplitBtns">
          <button class="btn" id="slbCmrAdmRefresh" type="button">Refresh</button>
        </div>
      </div>
      <div class="slbCmrViewerBody">
        <div id="slbCmrAdmEntries"></div>
        <div class="hr"></div>
        <div id="slbCmrAdmEntryViewer"><div class="slbCmrSmallNote">Open an entry.</div></div>
      </div>
    `;
  }

  function renderInboxEntries(cs, items){
    var box = qs('#slbCmrAdmEntries');
    if(!box) return;
    if(!items || !items.length){
      box.innerHTML = '<div class="slbCmrSmallNote">No CMR entries for this disciple.</div>';
      return;
    }
    box.innerHTML = items.map(function(it){
      var id = String(it.entryId||it.entryID||it.id||'').trim();
      var dk = fmtDateKey_(it.dateKey||'');
      var d0 = toDate_(it.createdAt || it.updatedAt || '');
      var tm = d0 ? fmtHm_(d0) : '';
      var upIso = String(it.updatedAt||it.createdAt||'');
      var upAgo = timeAgo_(upIso);
      var upTxt = fmtDateTime_(upIso);
      return `<div class="slbCmrRow" data-id="${esc(id)}">
        <div>
          <div style="font-weight:900;">${esc(dk)}${tm?(' · '+esc(tm)):''}</div>
          <div class="slbCmrMeta">${upAgo?('Updated '+esc(upAgo)):''}<\/div>
        </div>
        <div class="slbCmrMeta">›</div>
      </div>`;
    }).join('');
    qsa('.slbCmrRow', box).forEach(function(r){
      r.addEventListener('click', function(){ openInboxEntry(cs, r.getAttribute('data-id')); });
    });
  }

  function setInboxEntryViewer(html){
    var v = qs('#slbCmrAdmEntryViewer');
    if(v) v.innerHTML = html;
  }

  async function openInboxEntry(cs, entryId){
    cs = String(cs||'').toUpperCase();
    entryId = String(entryId||'').trim();
    if(!cs || !entryId) return;
    setInboxEntryViewer('<div class="slbCmrSmallNote">Loading...</div>');
    try{
      var res = await rpc('cmrGet', { callsign: cs, entryId: entryId, includeRich: true });
      var out = res && (res.result || res);
      var it = out && (out.item || out.entry || out);
      if(!it || !it.entryId) throw new Error('Not found');

      var reportHtml = (it.bodyRich && String(it.bodyRich).trim()) ? String(it.bodyRich) : nl2br(String(it.body||''));
      var notesHtml = (it.notesRich && String(it.notesRich).trim()) ? String(it.notesRich) : nl2br(String(it.notes||''));

      var dk = fmtDateKey_(it.dateKey||'');
      var d0 = toDate_(it.createdAt || it.updatedAt || '');
      var tm = d0 ? fmtHm_(d0) : '';
      var upIso = String(it.updatedAt||it.createdAt||'');
      var upAgo = timeAgo_(upIso);
      var upTxt = fmtDateTime_(upIso);

      var role = getRole();
      var canEdit = !!role.isAdmin;

      var edReport = buildMiniEditor({ id:'slbCmrAdmReportEd', label:'Report', placeholder:'Edit report...' });
      var edNotes = buildMiniEditor({ id:'slbCmrAdmNotesEd', label:'Notes', placeholder:'Edit notes...' });

      setInboxEntryViewer(`
        <div style="display:flex;justify-content:space-between;gap:10px;align-items:flex-start;flex-wrap:wrap;">
          <div>
            <div style="font-weight:900;">${esc(cs)} · ${esc(dk)}${tm?(' · '+esc(tm)):''}</div>
            <div class="slbCmrSmallNote">Updated: ${esc(upTxt)}${upAgo?(' ('+esc(upAgo)+')'):''}</div>
          </div>
          <div class="slbCmrSplitBtns">
            ${canEdit ? '<button class="btn" id="slbCmrAdmToggleEdit" type="button">Edit</button><button class="btn orange hidden" id="slbCmrAdmSave" type="button">Save</button><button class="btn danger" id="slbCmrAdmDelete" type="button">Delete</button>' : ''}
          </div>
        </div>

        <div id="slbCmrAdmReadMode" style="margin-top:10px;">
          <div class="slbCmrReport">${reportHtml}</div>
          <div style="margin-top:10px;">
            <div class="slbCmrSmallNote" style="margin-bottom:6px;">Notes</div>
            <div class="slbCmrReport">${notesHtml || '<div class="slbCmrSmallNote">No notes.</div>'}</div>
          </div>
        </div>

        <div id="slbCmrAdmEditMode" class="hidden" style="margin-top:10px;">
          ${edReport.html}
          <div style="margin-top:10px;">${edNotes.html}</div>
          <div class="slbCmrSmallNote" style="margin-top:8px;">Admin can edit both report and notes.</div>
        </div>
      `);

      var root = qs('#slbCmrAdmEntryViewer');
      var edN = wireMiniEditor(root, 'slbCmrAdmNotesEd');
      var edR = wireMiniEditor(root, 'slbCmrAdmReportEd');

      try{ var nb = document.getElementById('slbCmrAdmNotesEd'); if(nb) nb.setAttribute('contenteditable', canEdit ? 'false' : 'false'); }catch(_e){}
      if(edN) edN.setHtml(notesHtml);
      if(edR) edR.setHtml(reportHtml);

      if(canEdit){
        var btnT = qs('#slbCmrAdmToggleEdit', root);
        var btnS = qs('#slbCmrAdmSave', root);
        var btnD = qs('#slbCmrAdmDelete', root);
        if(btnD){
          btnD.addEventListener('click', async function(){
            if(!confirm('Delete this CMR entry? This cannot be undone.')) return;
            try{
              btnD.disabled = true;
              await rpc('cmrDelete', { entryId: entryId, callsign: cs });
              toast('Deleted.');
              await loadInboxList(true);
              renderInboxList();
              var firstCs = inboxState.callsigns && inboxState.callsigns.length ? inboxState.callsigns[0] : '';
              if(firstCs){
                inboxState.selectedCallsign = firstCs;
                renderInboxEntriesFor(firstCs);
              }else{
                setAdmEntryViewer('<div class="slbCmrSmallNote">No CMR entries.</div>');
              }
            }catch(e){ toast('Delete failed.'); }
            finally{ btnD.disabled = false; }
          });
        }
        var readMode = qs('#slbCmrAdmReadMode', root);
        var editMode = qs('#slbCmrAdmEditMode', root);

        function setEdit(on){
          if(on){
            readMode.classList.add('hidden'); editMode.classList.remove('hidden'); btnS.classList.remove('hidden'); btnT.textContent='Cancel';
            try{ var nb2=document.getElementById('slbCmrAdmNotesEd'); if(nb2) nb2.setAttribute('contenteditable','true'); }catch(_e2){}
            try{ var rb2=document.getElementById('slbCmrAdmReportEd'); if(rb2) rb2.setAttribute('contenteditable','true'); }catch(_e3){}
          }else{
            editMode.classList.add('hidden'); readMode.classList.remove('hidden'); btnS.classList.add('hidden'); btnT.textContent='Edit';
            try{ openInboxEntry(cs, entryId); }catch(_e4){}
          }
        }

        btnT.addEventListener('click', function(){
          var isOn = !editMode.classList.contains('hidden');
          if(isOn) setEdit(false);
          else setEdit(true);
        });

        btnS.addEventListener('click', async function(){
          try{
            btnS.disabled=true;
            var rh = edR ? edR.getHtml() : '';
            var rt = edR ? edR.getText() : '';
            var nh = edN ? edN.getHtml() : '';
            var nt = edN ? edN.getText() : '';
            await rpc('cmrUpsert', { callsign: cs, entryId: entryId, body: rt, bodyRich: rh, notes: nt, notesRich: nh });
            toast('Saved.');
            inboxState.listCache[cs] = null;
            await refreshInboxStats();
            renderInboxLeft(qs('#slbCmrSearch') ? qs('#slbCmrSearch').value : '');
            const items = await loadEntriesFor(cs, true);
            renderInboxEntries(cs, items);
            await openInboxEntry(cs, entryId);
          }catch(e){ toast('Save failed.'); }
          finally{ btnS.disabled=false; }
        });
      }

    }catch(e){
      setInboxEntryViewer('<div class="slbCmrSmallNote">Failed to load entry. ' + esc((e && e.message) ? e.message : '') + '</div>');
    }
  }

  async function selectDisciple(cs){
    cs = String(cs||'').toUpperCase();
    if(!cs) return;
    inboxState.selected = cs;
    renderInboxLeft(qs('#slbCmrSearch') ? qs('#slbCmrSearch').value : '');
    setInboxViewer(buildInboxViewerShell(cs));

    var btnR = qs('#slbCmrAdmRefresh');
    if(btnR){
      btnR.addEventListener('click', async function(){
        try{ btnR.disabled=true; inboxState.listCache[cs]=null; const items=await loadEntriesFor(cs,true); renderInboxEntries(cs,items); await refreshInboxStats(); renderInboxLeft(qs('#slbCmrSearch')?qs('#slbCmrSearch').value:''); }
        catch(e){ toast('Refresh failed.'); }
        finally{ btnR.disabled=false; }
      });
    }

    try{
      const items = await loadEntriesFor(cs,false);
      renderInboxEntries(cs, items);
      if(items && items.length) openInboxEntry(cs, String(items[0].entryId||items[0].entryID||items[0].id||''));
    }catch(e){
      renderInboxEntries(cs, []);
    }
  }

  async function bootInbox(){
    var root = document.getElementById('slbCmrInbox');
    if(!root) return;

    // Avoid duplicate listeners (and prevent accidental re-boot loops)
    if(root.dataset && root.dataset.slbBooted === '1'){
      return;
    }

    var role = getRole();
    if(!role.callsign){
      setInboxViewer('<div class="slbCmrViewerBody"><div class="slbCmrSmallNote">Loading profile...</div></div>');
      var __tries = 0;
      (function retry(){
        __tries++;
        var r = getRole();
        if(r && r.callsign){
          setTimeout(bootInbox, 0);
          return;
        }
        if(__tries > 20){
          setInboxViewer('<div class="slbCmrViewerBody"><div class="slbCmrSmallNote">Please login first.</div></div>');
          return;
        }
        setTimeout(retry, 250);
      })();
      return;
    }
if(!role.isAdmin && !role.isModerator){
      setInboxViewer('<div class="slbCmrViewerBody"><div class="slbCmrSmallNote">Forbidden.</div></div>');
      return;
    }

        if(root.dataset) root.dataset.slbBooted = '1';

setInboxViewer('<div class="slbCmrViewerBody"><div class="slbCmrSmallNote">Loading disciple list...</div></div>');

    // Load disciple roster
    var list=[];
    try{
      var res = await rpc('adminDiscipleList', { includeOut:false, limit: 10000 });
      var out = res && (res.result || res);
      var arr = (out && out.in) ? out.in : (out && out.items ? out.items : []);
      list = (arr||[]).map(function(x){
        var cs = String(x.callsign||x.callSign||x.cs||'').trim().toUpperCase();
        if(!cs) return null;
        var dn = String(x.displayName||x.name||x.fullName||x.legalName||'').trim();
        return { callsign: cs, displayName: dn };
      }).filter(Boolean);
      list.sort(function(a,b){ return String(a.callsign).localeCompare(String(b.callsign)); });
    }catch(e){
      setInboxViewer('<div class="slbCmrViewerBody"><div class="slbCmrSmallNote">Failed to load disciple list. ' + esc((e && e.message) ? e.message : '') + '</div></div>');
      return;
    }
    inboxState.disciples = list;
    await refreshInboxStats();
    renderInboxLeft('');
    setInboxViewer('<div class="slbCmrViewerBody"><div class="slbCmrSmallNote">Select a disciple on the left.</div></div>');

    var s = qs('#slbCmrSearch');
    if(s){
      var t=null;
      s.addEventListener('input', function(){ clearTimeout(t); t=setTimeout(function(){ renderInboxLeft(s.value); }, 120); });
    }

    // Auto-select the first disciple with stats
    var hot = null;
    for(var i=0;i<list.length;i++){ var cs = String(list[i].callsign||'').toUpperCase(); if(inboxState.statsBy[cs]){ hot = cs; break; } }
    if(!hot && list.length) hot = String(list[0].callsign||'').toUpperCase();
    if(hot) selectDisciple(hot);
  }

  // Boot on load (and safe to call many times)
  function bootAll(){
    try{ bootUser(); }catch(_e){}
    try{ bootInbox(); }catch(_e2){}
  }

  // Boot now and also on tab clicks (if loaded before panel shown)
  bootAll();
  document.addEventListener('click', function(ev){
    var t = ev.target;
    if(!t) return;
    var tab = t.getAttribute && t.getAttribute('data-tab');
    if(tab === 'cmr' || tab === 'cmrInbox'){
      setTimeout(bootAll, 0);
    }
  }, true);

})();
